// @flow
import { defineMessages } from 'react-intl';

const localizedStrings = defineMessages({
  ABOUT: {
    id: 'ABOUT',
    defaultMessage: 'About',
  },
  ABOUT_API_TAB: {
    id: 'ABOUT_API_TAB',
    defaultMessage: 'API',
  },
  ABOUT_VERSION: {
    id: 'ABOUT_VERSION',
    defaultMessage: 'Version',
  },
  ABOUT_EXTENSIS_URL: {
    id: 'ABOUT_EXTENSIS_URL',
    defaultMessage: 'www.portfoliodam.com',
  },
  ABOUT_PORTFOLIO_SERVER: {
    id: 'ABOUT_PORTFOLIO_SERVER',
    defaultMessage: 'Portfolio Server',
  },
  ABOUT_PORTFOLIO_VERSION: {
    id: 'ABOUT_PORTFOLIO_VERSION',
    defaultMessage: 'Version 9.0',
  },
  ABOUT_SERVER_TAB: {
    id: 'ABOUT_SERVER_TAB',
    defaultMessage: 'Server',
  },
  accessOriginals: {
    id: 'accessOriginals',
    defaultMessage: 'Access and Process Originals',
  },
  ACCOUNT_TYPE: {
    id: 'ACCOUNT_TYPE',
    defaultMessage: 'Authentication',
  },
  ACCOUNT_TYPE_LDAP: {
    id: 'ACCOUNT_TYPE_LDAP',
    defaultMessage: 'Directory Service',
  },
  ACCOUNT_TYPE_MANUAL: {
    id: 'ACCOUNT_TYPE_MANUAL',
    defaultMessage: 'Native (Built-in)',
  },
  ACTIVE_DIRECTORY: {
    id: 'ACTIVE_DIRECTORY',
    defaultMessage: 'Active Directory',
  },
  ADD: {
    id: 'ADD',
    defaultMessage: 'Add',
  },
  addAsset: {
    id: 'addAsset',
    defaultMessage: 'Add Assets',
  },
  ALL_CATALOGS_GROUP: {
    id: 'ALL_CATALOGS_GROUP',
    defaultMessage: 'All Catalogs',
  },
  API_CODE_REFERENCE: {
    id: 'API_CODE_REFERENCE',
    defaultMessage: 'API Code Reference (English)',
  },
  API_CODE_REFERENCE_URL: {
    id: 'API_CODE_REFERENCE_URL',
    defaultMessage: 'https://doc.portfoliodam.com/api/portfolio/index.html',
  },
  API_DEVELOPER_COMMUNITY: {
    id: 'API_DEVELOPER_COMMUNITY',
    defaultMessage: 'Developer Community',
  },
  API_DEVELOPER_COMMUNITY_URL: {
    id: 'API_DEVELOPER_COMMUNITY_URL',
    defaultMessage:
      'https://forums.portfolio.com/c/digital-asset-management/portfolio-api-developer-community',
  },
  API_PORTFOLIO_HELP: {
    id: 'API_PORTFOLIO_HELP',
    defaultMessage: 'Portfolio Administration Help',
  },
  API_PORTFOLIO_HELP_URL: {
    id: 'API_PORTFOLIO_HELP_URL',
    defaultMessage:
      'https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm',
  },
  API_SECTION_1: {
    id: 'API_SECTION_1',
    defaultMessage:
      'The Portfolio API provides a common interface for developers to integrate Portfolio catalogs, asset metadata, and media processing into business systems, custom workflows, and web infrastructures.',
  },
  API_SECTION_2_PART_1: {
    id: 'API_SECTION_2_PART_1',
    defaultMessage: 'Use of the API requires licenses, as described in the ',
  },
  API_SECTION_2_PART_2: {
    id: 'API_SECTION_2_PART_2',
    defaultMessage:
      ". To view or edit license information, click 'Licenses' in the Portfolio Administration application.",
  },
  API_SECTION_2_EULA: {
    id: 'API_SECTION_2_EULA',
    defaultMessage: 'Portfolio EULA',
  },
  API_SECTION_2_EULA_URL: {
    id: 'API_SECTION_2_EULA_URL',
    defaultMessage:
      'https://helpdocs.portfolio.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm',
  },
  API_SECTION_2_PART_3: {
    id: 'API_SECTION_2_PART_3',
    defaultMessage: 'Learn more:',
  },
  API_TOKEN_CREATE: {
    id: 'API_TOKEN_CREATE',
    defaultMessage: 'Add New API Token',
  },
  APPLY: {
    id: 'APPLY',
    defaultMessage: 'Apply',
  },
  APP_PAGE_TITLE: {
    id: 'APP_PAGE_TITLE',
    defaultMessage: 'Portfolio Admin',
  },
  ASSETS: {
    id: 'ASSETS',
    defaultMessage: 'Assets',
  },
  AT_TIME: {
    id: 'AT_TIME',
    defaultMessage: 'at',
  },
  AUTHENTICATION_ERROR: {
    id: 'AUTHENTICATION_ERROR',
    defaultMessage:
      'Directory service authentication failed. Please check your username and password.',
  },
  BACKUP_BACKUP_BUTTON: {
    id: 'BACKUP_BACKUP_BUTTON',
    defaultMessage: 'Backup',
  },
  BACKUP_BACKUP_LABEL: {
    id: 'BACKUP_BACKUP_LABEL',
    defaultMessage: 'Backup',
  },
  BACKUP_BACKUP_NOW_BUTTON: {
    id: 'BACKUP_BACKUP_NOW_BUTTON',
    defaultMessage: 'Backup Now',
  },
  BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE: {
    id: 'BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE',
    defaultMessage:
      'To change the backup location, first shut down Portfolio server.',
  },
  BACKUP_CONFIRMATION_VERBIAGE: {
    id: 'BACKUP_CONFIRMATION_VERBIAGE',
    defaultMessage:
      ' Backup now? Portfolio will be offline until backup is complete.',
  },
  BACKUP_DIRECTORY_LABEL: {
    id: 'BACKUP_DIRECTORY_LABEL',
    defaultMessage: 'Store in Directory',
  },
  BACKUP_DIRECTORY_ERROR_MSG: {
    id: 'BACKUP_DIRECTORY_ERROR_MSG',
    defaultMessage: 'The selected backup directory is not valid.',
  },
  BACKUP_EXPLANATION_TEXT_1: {
    id: 'BACKUP_EXPLANATION_TEXT_1',
    defaultMessage:
      'Backups capture and safely store the server database and settings.\nIt does not backup your original asset files!',
  },
  BACKUP_EXPLANATION_TEXT_2: {
    id: 'BACKUP_EXPLANATION_TEXT_2',
    defaultMessage: 'The server will be inaccessible during backups.',
  },
  BACKUP_FILES_LABEL: {
    id: 'BACKUP_FILES_LABEL',
    defaultMessage: 'Backup Files',
  },
  BACKUP_FRIDAY_LABEL: {
    id: 'BACKUP_FRIDAY_LABEL',
    defaultMessage: 'Friday',
  },
  BACKUP_MONDAY_LABEL: {
    id: 'BACKUP_MONDAY_LABEL',
    defaultMessage: 'Monday',
  },
  BACKUP_MOST_RECENT_LABEL: {
    id: 'BACKUP_MOST_RECENT_LABEL',
    defaultMessage: 'Most Recent Backup',
  },
  BACKUP_NEXT_SCHEDULED_LABEL: {
    id: 'BACKUP_NEXT_SCHEDULED_LABEL',
    defaultMessage: 'Next Scheduled Backup',
  },
  BACKUP_NOTIFICATIONS: {
    id: 'BACKUP_NOTIFICATIONS',
    defaultMessage: 'Send email notifications after backups and restores',
  },
  BACKUP_NOTIFICATIONS_DISABLED_MSG: {
    id: 'BACKUP_NOTIFICATIONS_DISABLED_MSG',
    defaultMessage:
      'Email notifications must be enabled in Global Settings > Email Notifications',
  },
  BACKUP_PROGRESS_BACKING_UP: {
    id: 'BACKUP_PROGRESS_BACKING_UP',
    defaultMessage: 'Backing Up',
  },
  BACKUP_PROGRESS_BACKING_UP_DATA: {
    id: 'BACKUP_PROGRESS_BACKING_UP_DATA',
    defaultMessage: 'Backing up data...',
  },
  BACKUP_PROGRESS_BACKUP_CANCELLED: {
    id: 'BACKUP_PROGRESS_BACKUP_CANCELLED',
    defaultMessage: 'Backup Cancelled',
  },
  BACKUP_PROGRESS_BACKUP_FAILED: {
    id: 'BACKUP_PROGRESS_BACKUP_FAILED',
    defaultMessage: 'Backup Failed',
  },
  BACKUP_PROGRESS_BACKUP_SUCCESSFUL: {
    id: 'BACKUP_PROGRESS_BACKUP_SUCCESSFUL',
    defaultMessage: 'Backup Successful',
  },
  BACKUP_PROGRESS_PREFLIGHT: {
    id: 'BACKUP_PROGRESS_PREFLIGHT',
    defaultMessage: 'Checking for available space...',
  },
  BACKUP_PROGRESS_RESTARTING: {
    id: 'BACKUP_PROGRESS_RESTARTING',
    defaultMessage: 'Restarting server...',
  },
  BACKUP_PROGRESS_RESTORE_FAILED: {
    id: 'BACKUP_PROGRESS_RESTORE_FAILED',
    defaultMessage: 'Restore Failed',
  },
  BACKUP_PROGRESS_RESTORE_SUCCESSFUL: {
    id: 'BACKUP_PROGRESS_RESTORE_SUCCESSFUL',
    defaultMessage: 'Restore Successful',
  },
  BACKUP_PROGRESS_RESTORING: {
    id: 'BACKUP_PROGRESS_RESTORING',
    defaultMessage: 'Restoring',
  },
  BACKUP_PROGRESS_RESTORING_DATA: {
    id: 'BACKUP_PROGRESS_RESTORING_DATA',
    defaultMessage: 'Restoring data...',
  },
  BACKUP_PROGRESS_SHUTTING_DOWN: {
    id: 'BACKUP_PROGRESS_SHUTTING_DOWN',
    defaultMessage: 'Shutting down server...',
  },
  BACKUP_PROGRESS_SUMMARY: {
    id: 'BACKUP_PROGRESS_SUMMARY',
    defaultMessage: 'Step {stepNum} of {totalSteps}',
  },
  BACKUP_RESTORE_BUTTON: {
    id: 'BACKUP_RESTORE_BUTTON',
    defaultMessage: 'Restore From Backup',
  },
  BACKUP_RESTORE_CONFIRMATION_VERBIAGE: {
    id: 'BACKUP_RESTORE_CONFIRMATION_VERBIAGE',
    defaultMessage:
      'Restore backup now? Portfolio will be offline until restore is complete. This will overwrite your current database and settings.',
  },
  BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE: {
    id: 'BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE',
    defaultMessage:
      'The backup archive is corrupt.\nChoose another backup to restore from.',
  },
  BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE: {
    id: 'BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE',
    defaultMessage:
      'The backup disk has insufficient space\nto complete.\n\n{requiredSpace} required, {availableSpace} available.',
  },
  BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY: {
    id: 'BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY',
    defaultMessage:
      'The currently configured backup location does not exist. The backup location is used to unzip the archive when a backup is being restored. Please reset the backup location to a valid directory.',
  },
  BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP: {
    id: 'BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP',
    defaultMessage:
      'There was a problem with the backup.\nSee admin logs for details.',
  },
  BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE: {
    id: 'BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE',
    defaultMessage:
      'There was a problem with the restore.\nSee admin logs for details.',
  },
  BACKUP_RESTORE_LABEL: {
    id: 'BACKUP_RESTORE_LABEL',
    defaultMessage: 'Restore',
  },
  BACKUP_RESTORE_TITLE: {
    id: 'BACKUP_RESTORE_TITLE',
    defaultMessage: 'Backup/Restore',
  },
  BACKUP_RETAIN_LABEL: {
    id: 'BACKUP_RETAIN_LABEL',
    defaultMessage: 'Retain',
  },
  BACKUP_RETAIN_VALUE: {
    id: 'BACKUP_RETAIN_VALUE',
    defaultMessage: 'Keep only the {numBackups} most recent backups',
  },
  BACKUP_SATURDAY_LABEL: {
    id: 'BACKUP_SATURDAY_LABEL',
    defaultMessage: 'Saturday',
  },
  BACKUP_SCHEDULE_LABEL: {
    id: 'BACKUP_SCHEDULE_LABEL',
    defaultMessage: 'Schedule Backups',
  },
  BACKUP_SCHEDULE_VALUE: {
    id: 'BACKUP_SCHEDULE_VALUE',
    defaultMessage: 'on',
  },
  BACKUP_SUNDAY_LABEL: {
    id: 'BACKUP_SUNDAY_LABEL',
    defaultMessage: 'Sunday',
  },
  BACKUP_THURSDAY_LABEL: {
    id: 'BACKUP_THURSDAY_LABEL',
    defaultMessage: 'Thursday',
  },
  BACKUP_TUESDAY_LABEL: {
    id: 'BACKUP_TUESDAY_LABEL',
    defaultMessage: 'Tuesday',
  },
  BACKUP_WEDNESDAY_LABEL: {
    id: 'BACKUP_WEDNESDAY_LABEL',
    defaultMessage: 'Wednesday',
  },
  BROWSE: {
    id: 'BROWSE',
    defaultMessage: 'Browse',
  },
  BROWSE_FOLDERS_TITLE: {
    id: 'BROWSE_FOLDERS_TITLE',
    defaultMessage: 'Browse Server Folders',
  },
  BROWSE_RECENT_FOLDERS_LABEL: {
    id: 'BROWSE_RECENT_FOLDERS_LABEL',
    defaultMessage: 'Recent Folders',
  },
  BROWSE_REFRESH: {
    id: 'BROWSE_REFRESH',
    defaultMessage: 'Synchronize items',
  },
  CALL_ATT_BUTTON_BUY_NOW: {
    id: 'CALL_ATT_BUTTON_BUY_NOW',
    defaultMessage: 'Buy Now',
  },
  CALL_ATT_BUTTON_SECONDARY: {
    id: 'CALL_ATT_BUTTON_SECONDARY',
    defaultMessage: 'Contact Sales for a Quote',
  },
  CALL_ATT_FADEL_BUTTON_MAIN: {
    id: 'CALL_ATT_FADEL_BUTTON_MAIN',
    defaultMessage: 'Contact Sales for More Information',
  },
  CALL_ATT_FADEL_MAIN: {
    id: 'CALL_ATT_FADEL_MAIN',
    defaultMessage:
      'Ensure proper usage of your licensed content, from images to videos and everything in between. Portfolio seamlessly connects with FADEL Rights Cloud software so you can see and easily understand the usage rights associated with your assets—helping you to remove workflow bottlenecks and reduce the risk of expensive copyright violations.',
  },
  CALL_ATT_FADEL_SUBTITLE: {
    id: 'CALL_ATT_FADEL_SUBTITLE',
    defaultMessage: 'Know your asset usage rights',
  },
  CALL_ATT_FADEL_TITLE: {
    id: 'CALL_ATT_FADEL_TITLE',
    defaultMessage: 'FADEL RIGHTS CLOUD',
  },
  CALL_ATT_ME_SUBTITLE: {
    id: 'CALL_ATT_ME_SUBTITLE',
    defaultMessage: 'High-Performance Processing and Conversion',
  },
  CALL_ATT_ME_MAIN: {
    id: 'CALL_ATT_ME_MAIN',
    defaultMessage:
      'Are you pushing the performance limits of your Portfolio server? With Media Engine, avoid slowdowns and improve overall productivity by eliminating the bottlenecks caused by busy production environments.\n\n\t• Increases capacity and throughput\n\t• Unlocks additional output formats\n\t• Accelerates video preview creation\n\t• Add multiple Media Engines as needed\n\t• Watermarking (requires NetPublish)',
  },
  CALL_ATT_ME_BUTTON_MAIN: {
    id: 'CALL_ATT_ME_BUTTON_MAIN',
    defaultMessage: 'Get Media Engine',
  },
  CALL_ATT_NP_SUBTITLE: {
    id: 'CALL_ATT_NP_SUBTITLE',
    defaultMessage: 'Self-Service Portals to Access Assets Instantly',
  },
  CALL_ATT_NP_MAIN: {
    id: 'CALL_ATT_NP_MAIN',
    defaultMessage:
      "Tired of those last minute requests every time someone needs an asset? With NetPublish, it's easy to post self-serve websites that allow anyone to locate and download the assets they need from any browser on any device.\n\n\t• One-click site creation - no HTML or CSS required\n\t• Mobile-friendly, responsive design\n\t• Flexible user access control\n\t• Deactivate sites automatically\n\t• Set resolution, size and format on download\n\t• Watermarking (requires Media Engine)\n\t• Usage reporting",
  },
  CALL_ATT_NP_BUTTON_MAIN: {
    id: 'CALL_ATT_NP_BUTTON_MAIN',
    defaultMessage: 'Get NetPublish',
  },
  CALL_ATT_REPORT_TITLE: {
    id: 'CALL_ATT_REPORT_TITLE',
    defaultMessage: 'Reporting for NetPublish',
  },
  CALL_ATT_REPORT_SUBTITLE: {
    id: 'CALL_ATT_REPORT_SUBTITLE',
    defaultMessage: 'Relevant Usage Insight',
  },
  CALL_ATT_REPORT_MAIN: {
    id: 'CALL_ATT_REPORT_MAIN',
    defaultMessage:
      'Want to know which sites are most active, what assets are getting used and by whom? With NetPublish reporting, get the insight you need to make informed decisions based on how Portfolio is being used at your organization.\n\nUsage breakdown by:\n\t• NetPublish site name\n\t• Username\n\t• Asset name and ID\n\t• Date and time',
  },
  CALL_ATT_REPORT_BUTTON_MAIN: {
    id: 'CALL_ATT_REPORT_BUTTON_MAIN',
    defaultMessage: 'Get NetPublish',
  },
  CALL_ATT_SK_BUTTON_MAIN: {
    id: 'CALL_ATT_SK_BUTTON_MAIN',
    defaultMessage: 'Try it for Free',
  },
  CALL_ATT_SK_BUTTON_TRY_NOW: {
    id: 'CALL_ATT_SK_BUTTON_TRY_NOW',
    defaultMessage: 'http://extens.is/wqqb',
  },
  CALL_ATT_SK_MAIN: {
    id: 'CALL_ATT_SK_MAIN',
    defaultMessage:
      'Looking for a way to accelerate your process for assigning keywords to images? With Portfolio Smart Keywords, you can automatically assign “smart” keywords to your images with just one click. Powered by Clarifai, an innovative artificial intelligence company that excels in visual recognition technology, a list of suggested keywords is delivered in seconds.\n\n\t• Delivers a list of smart keywords in seconds\n\t• Saves time and resources by reducing manual keywording\n\t• Establishes a consistent taxonomy for your organization\n\t• Makes it easy to find your digital assets quickly',
  },
  CALL_ATT_SK_SUBTITLE: {
    id: 'CALL_ATT_SK_SUBTITLE',
    defaultMessage: 'Automate Your Image Keywording',
  },
  CALL_ATT_SK_TITLE: {
    id: 'CALL_ATT_SK_TITLE',
    defaultMessage: 'Portfolio Smart Keywords',
  },
  CALL_ATT_SSO_SUBTITLE: {
    id: 'CALL_ATT_SSO_SUBTITLE',
    defaultMessage: 'Seamless User Experience Across Platforms',
  },
  CALL_ATT_SSO_TITLE: {
    id: 'CALL_ATT_SSO_TITLE',
    defaultMessage: 'Single Sign-On',
  },
  CALL_ATT_SSO_MAIN: {
    id: 'CALL_ATT_SSO_MAIN',
    defaultMessage:
      'Are people in your organization having a hard time keeping their login credentials straight? Typically, with new solutions come extra overhead in managing user accounts, both for you and for the users.\n\nFortunately, Portfolio supports Single Sign-On with Active Directory. Using Single Sign-On, users can login to Portfolio automatically from your intranet site giving them a continuous user experience.\n\n\t• Supports Windows Server Active Directory\n\t• Improves overall security\n\t• Simplifies user management\n\t• Improves user experience',
  },
  CALL_ATT_SSO_BUTTON_MAIN: {
    id: 'CALL_ATT_SSO_BUTTON_MAIN',
    defaultMessage: 'Get Single Sign-On',
  },
  CALL_ATT_URL_BUY_NOW: {
    id: 'CALL_ATT_URL_BUY_NOW',
    defaultMessage: 'https://secure.portfolios.com/portfolio-options',
  },
  CALL_ATT_URL_CONTACT_SALES: {
    id: 'CALL_ATT_URL_CONTACT_SALES',
    defaultMessage: 'https://portfoliodam.com/portfolio/contact-me',
  },
  canEmbedMetadata: {
    id: 'canEmbedMetadata',
    defaultMessage: 'Embed Metadata',
  },
  canImportMetadata: {
    id: 'canImportMetadata',
    defaultMessage: 'Import/Export Metadata',
  },
  canManageFieldLists: {
    id: 'canManageFieldLists',
    defaultMessage: 'Manage Public Field Lists',
  },
  canManagePublicGallery: {
    id: 'canManagePublicGallery',
    defaultMessage: 'Manage Public Galleries',
  },
  canModifyFolderStructure: {
    id: 'canModifyFolderStructure',
    defaultMessage: 'Modify Folder Structures',
  },
  canMoveAssets: {
    id: 'canMoveAssets',
    defaultMessage: 'Move Assets',
  },
  canPublishNetPublishSites: {
    id: 'canPublishNetPublishSites',
    defaultMessage: 'Publish NetPublish Sites',
  },
  canSmartKeyword: {
    id: 'canSmartKeyword',
    defaultMessage: 'Can Smart Keyword',
  },
  CANCEL: {
    id: 'CANCEL',
    defaultMessage: 'Cancel',
  },
  CATALOG: {
    id: 'CATALOG',
    defaultMessage: 'Catalog',
  },
  CATALOG_ADD_SELECTED_USERS_TO_CATALOG: {
    id: 'CATALOG_ADD_SELECTED_USERS_TO_CATALOG',
    defaultMessage: 'Grant Membership',
  },
  CATALOG_BACKUP: {
    id: 'CATALOG_BACKUP',
    defaultMessage: 'Backup Selected Catalog',
  },
  CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS: {
    id: 'CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS',
    defaultMessage:
      'Change { affectedUsersCount, plural, one {Role} other {Roles} }',
  },
  CATALOG_CREATE: {
    id: 'CATALOG_CREATE',
    defaultMessage: 'Add New Catalog',
  },
  CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG: {
    id: 'CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG',
    defaultMessage:
      'Catalog Administrators can add AutoSync folders from the Desktop Client.',
  },
  CATALOG_CREATE_AUTOSYNC_FOLDER: {
    id: 'CATALOG_CREATE_AUTOSYNC_FOLDER',
    defaultMessage: 'Create an AutoSync folder',
  },
  CATALOG_CREATE_CATALOG_TEMPLATE: {
    id: 'CATALOG_CREATE_CATALOG_TEMPLATE',
    defaultMessage: 'Save Catalog Template',
  },
  CATALOG_TYPE_GENERAL: {
    id: 'CATALOG_TYPE_GENERAL',
    defaultMessage: 'General Use',
  },
  CATALOG_TYPE_SIMPLE: {
    id: 'CATALOG_TYPE_SIMPLE',
    defaultMessage: 'Simple',
  },
  CATALOG_CREATE_DATABASES_LIST_LABEL: {
    id: 'CATALOG_CREATE_DATABASES_LIST_LABEL',
    defaultMessage: 'Databases',
  },
  CATALOG_CREATE_ERROR_CREATING_FOLDERS: {
    id: 'CATALOG_CREATE_ERROR_CREATING_FOLDERS',
    defaultMessage:
      'An error was encountered when creating the {folder} folder.',
  },
  CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG: {
    id: 'CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG',
    defaultMessage:
      'Default folders for AutoSync and Previews can be configured in Global Settings.',
  },
  CATALOG_CREATE_NAME: {
    id: 'CATALOG_CREATE_NAME',
    defaultMessage: 'Name',
  },
  CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG: {
    id: 'CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG',
    defaultMessage: 'Previews can be configured in Catalog Details.',
  },
  CATALOG_CREATE_PREVIEW_FOLDER: {
    id: 'CATALOG_CREATE_PREVIEW_FOLDER',
    defaultMessage: 'Save Previews for faster previewing',
  },
  CATALOG_CREATE_SHOW_DATABASES: {
    id: 'CATALOG_CREATE_SHOW_DATABASES',
    defaultMessage: 'Show Databases',
  },
  CATALOG_CREATE_USE_VERSIONING: {
    id: 'CATALOG_CREATE_USE_VERSIONING',
    defaultMessage: 'Use Asset Versioning',
  },
  CATALOG_DELETE: {
    id: 'CATALOG_DELETE',
    defaultMessage: 'Delete Catalog',
  },
  CATALOG_DELETE_CONFIRM: {
    id: 'CATALOG_DELETE_CONFIRM',
    defaultMessage: 'Do you want to delete the selected catalog?',
  },
  CATALOG_DETAILS: {
    id: 'CATALOG_DETAILS',
    defaultMessage: 'Catalog Details',
  },
  CATALOG_DETAILS_CHANGE_NAME_PROMPT: {
    id: 'CATALOG_DETAILS_CHANGE_NAME_PROMPT',
    defaultMessage:
      'To rename this catalog we must temporarily take it offline, do you want to continue?',
  },
  CATALOG_DETAILS_COLLATION: {
    id: 'CATALOG_DETAILS_COLLATION',
    defaultMessage: 'Collation',
  },
  CATALOG_DETAILS_COLLATION_NA: {
    id: 'CATALOG_DETAILS_COLLATION_NA',
    defaultMessage: 'N/A',
  },
  CATALOG_DETAILS_CREATION_DATE: {
    id: 'CATALOG_DETAILS_CREATION_DATE',
    defaultMessage: 'Creation Date',
  },
  CATALOG_DETAILS_DATABASE_TAB: {
    id: 'CATALOG_DETAILS_DATABASE_TAB',
    defaultMessage: 'General',
  },
  CATALOG_DETAILS_FILETYPES_TAB: {
    id: 'CATALOG_DETAILS_FILETYPES_TAB',
    defaultMessage: 'File Types',
  },
  CATALOG_DETAILS_LAST_MODIFIED: {
    id: 'CATALOG_DETAILS_LAST_MODIFIED',
    defaultMessage: 'Last Modified',
  },
  CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS: {
    id: 'CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS',
    defaultMessage: 'Connected Users',
  },
  CATALOG_DETAILS_NUMBER_OF_RECORDS: {
    id: 'CATALOG_DETAILS_NUMBER_OF_RECORDS',
    defaultMessage: 'Records',
  },
  CATALOG_DETAILS_NUMBER_OF_USERS: {
    id: 'CATALOG_DETAILS_NUMBER_OF_USERS',
    defaultMessage: 'Members',
  },
  CATALOG_DETAILS_SIZE_ON_DISK: {
    id: 'CATALOG_DETAILS_SIZE_ON_DISK',
    defaultMessage: 'Size on disk',
  },
  CATALOG_DETAILS_WARN_DISCONNECT_ADMIN: {
    id: 'CATALOG_DETAILS_WARN_DISCONNECT_ADMIN',
    defaultMessage: 'The administrator user will be disconnected. Proceed?',
  },
  CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION: {
    id: 'CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION',
    defaultMessage: 'Locked for administration',
  },
  CATALOG_DETAILS_UNLOCK: {
    id: 'CATALOG_DETAILS_UNLOCK',
    defaultMessage: 'Unlock',
  },
  CATALOG_EXPLANATION_VAULT_1: {
    id: 'CATALOG_EXPLANATION_VAULT_1',
    defaultMessage: 'Vault catalogs store assets in a secure repository.',
  },
  CATALOG_EXPLANATION_VAULT_2: {
    id: 'CATALOG_EXPLANATION_VAULT_2',
    defaultMessage:
      'Vault catalogs support locking, versioning, check-out and check-in.',
  },
  CATALOG_EXPLANATION_WF_1: {
    id: 'CATALOG_EXPLANATION_WF_1',
    defaultMessage:
      'Watch Folder catalogs track assets in place in your file system.',
  },
  CATALOG_EXPLANATION_WF_2: {
    id: 'CATALOG_EXPLANATION_WF_2',
    defaultMessage: 'Watch Folder catalogs support AutoSync.',
  },
  CATALOG_FILES_TAB_TITLE: {
    id: 'CATALOG_FILES_TAB_TITLE',
    defaultMessage: 'Ingest',
  },
  CATALOG_INGEST_DRAG_HINT_TEXT: {
    id: 'CATALOG_INGEST_DRAG_HINT_TEXT',
    defaultMessage:
      'To add fields to the Upload Form, drag them over from the Fields list.',
  },
  CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL: {
    id: 'CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL',
    defaultMessage: 'Fields for Upload Form',
  },
  CATALOG_INGEST_FIELDS_LABEL: {
    id: 'CATALOG_INGEST_FIELDS_LABEL',
    defaultMessage: 'Fields',
  },
  CATALOG_INGEST_FORM_HEADER_LABEL: {
    id: 'CATALOG_INGEST_FORM_HEADER_LABEL',
    defaultMessage: 'Form Header',
  },
  CATALOG_INGEST_HEADER_HINT_TEXT: {
    id: 'CATALOG_INGEST_HEADER_HINT_TEXT',
    defaultMessage:
      'The form header is optional and appears at the top of the form.',
  },
  CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE: {
    id: 'CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE',
    defaultMessage:
      'The maximum number of fields to add to a form is {maxFields}.',
  },
  CATALOG_INGEST_TAB_TITLE: {
    id: 'CATALOG_INGEST_TAB_TITLE',
    defaultMessage: 'Managed Upload',
  },
  CATALOG_INGEST_USE_INGEST_LABEL: {
    id: 'CATALOG_INGEST_USE_INGEST_LABEL',
    defaultMessage: 'Use Managed Upload',
  },
  CATALOG_INGEST_REQUIRED_LABEL: {
    id: 'CATALOG_INGEST_REQUIRED_LABEL',
    defaultMessage: 'Required',
  },
  CATALOG_IS_CONNECTED: {
    id: 'CATALOG_IS_CONNECTED',
    defaultMessage: 'Connected',
  },
  CATALOG_IS_DEFAULT: {
    id: 'CATALOG_IS_DEFAULT',
    defaultMessage: 'Default',
  },
  CATALOG_MANAGE_USERS: {
    id: 'CATALOG_MANAGE_USERS',
    defaultMessage: 'Manage Catalog Membership',
  },
  CATALOG_MANAGE_FIELDS: {
    id: 'CATALOG_MANAGE_FIELDS',
    defaultMessage: 'Manage Catalog Fields',
  },
  CATALOG_MANAGE_TEMPLATES_MENU_LABEL: {
    id: 'CATALOG_MANAGE_TEMPLATES_MENU_LABEL',
    defaultMessage: 'Manage Catalog Templates...',
  },
  CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE: {
    id: 'CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE',
    defaultMessage: 'Manage Custom Catalog Templates',
  },
  CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER: {
    id: 'CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER',
    defaultMessage: 'Catalog Template Name',
  },
  CATALOG_MEMBER: {
    id: 'CATALOG_MEMBER',
    defaultMessage: 'Member',
  },
  CATALOG_NEW_CATALOG_DETAILS: {
    id: 'CATALOG_NEW_CATALOG_DETAILS',
    defaultMessage: 'New Catalog Details',
  },
  CATALOG_OFFLINE: {
    id: 'CATALOG_OFFLINE',
    defaultMessage: 'Offline',
  },
  CATALOG_ONLINE: {
    id: 'CATALOG_ONLINE',
    defaultMessage: 'Online',
  },
  CATALOG_OPTIONS_ALL_FILE_TYPES: {
    id: 'CATALOG_OPTIONS_ALL_FILE_TYPES',
    defaultMessage: 'Catalog All File Types',
  },
  CATALOG_OPTIONS_ONLY_FILE_TYPES: {
    id: 'CATALOG_OPTIONS_ONLY_FILE_TYPES',
    defaultMessage: 'Catalog Only',
  },
  CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL: {
    id: 'CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL',
    defaultMessage: 'Create Keywords from Path',
  },
  CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME: {
    id: 'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME',
    defaultMessage: 'Filename',
  },
  CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT: {
    id: 'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT',
    defaultMessage: 'Parent Folder',
  },
  CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER: {
    id: 'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER',
    defaultMessage: 'Server Name',
  },
  CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE: {
    id: 'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE',
    defaultMessage: 'Folder Tree',
  },
  CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME: {
    id: 'CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME',
    defaultMessage: 'Volume',
  },
  CATALOG_OPTIONS_EXCLUSION_LABEL: {
    id: 'CATALOG_OPTIONS_EXCLUSION_LABEL',
    defaultMessage: 'File and Folder Exclusions',
  },
  CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION: {
    id: 'CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION',
    defaultMessage: 'Remove the selected file type(s)?',
  },
  CATALOG_TEMPLATES_TITLE: {
    id: 'CATALOG_TEMPLATES_TITLE',
    defaultMessage: 'Catalog Templates',
  },
  endsWith: {
    id: 'endsWith',
    defaultMessage: 'Ends with',
  },
  contains: {
    id: 'contains',
    defaultMessage: 'Contains',
  },
  startsWith: {
    id: 'startsWith',
    defaultMessage: 'Starts with',
  },
  CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION: {
    id: 'CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION',
    defaultMessage: 'Remove the selected exclusion(s)?',
  },
  CATALOG_OPTIONS_TAB_TITLE: {
    id: 'CATALOG_OPTIONS_TAB_TITLE',
    defaultMessage: 'Cataloging Options',
  },
  CATALOG_PREVIEWS_DEFAULT_LOCATION_IS: {
    id: 'CATALOG_PREVIEWS_DEFAULT_LOCATION_IS',
    defaultMessage: 'The default location is',
  },
  CATALOG_PREVIEWS_DIMENSIONS_LABEL: {
    id: 'CATALOG_PREVIEWS_DIMENSIONS_LABEL',
    defaultMessage:
      'Minimum size 300 pixels, maximum size 4000 pixel (longest dimension)',
  },
  CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES: {
    id: 'CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES',
    defaultMessage: 'Generate clips for audio/video files',
  },
  CATALOG_PREVIEWS_GENERATE_PREVIEWS: {
    id: 'CATALOG_PREVIEWS_GENERATE_PREVIEWS',
    defaultMessage: 'Create Previews',
  },
  CATALOG_PREVIEWS_FOLDER_LOCATION: {
    id: 'CATALOG_PREVIEWS_FOLDER_LOCATION',
    defaultMessage: 'Save previews and clips in this folder',
  },
  CATALOG_PREVIEWS_LOCATION_WARNING_INFO: {
    id: 'CATALOG_PREVIEWS_LOCATION_WARNING_INFO',
    defaultMessage: 'This location must be accessible to the server.',
  },
  CATALOG_PREVIEWS_MAX_PIXELS: {
    id: 'CATALOG_PREVIEWS_MAX_PIXELS',
    defaultMessage: 'Maximum image size',
  },
  CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION: {
    id: 'CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION',
    defaultMessage: 'Maximum video resolution',
  },
  CATALOG_PREVIEWS_MINUTES: {
    id: 'CATALOG_PREVIEWS_MINUTES',
    defaultMessage: 'minutes',
  },
  CATALOG_PREVIEWS_PIXELS: {
    id: 'CATALOG_PREVIEWS_PIXELS',
    defaultMessage: 'pixels',
  },
  CATALOG_PREVIEWS_SHORT: {
    id: 'CATALOG_PREVIEWS_SHORT',
    defaultMessage: 'Previews',
  },
  CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION: {
    id: 'CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION',
    defaultMessage: 'Limit duration to',
  },
  CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT: {
    id: 'CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT',
    defaultMessage:
      'Generating clips can take a while to process.\nTo shorten the processing time, choose a lower resolution and duration.',
  },
  CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG: {
    id: 'CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG',
    defaultMessage: 'Revoke Membership',
  },
  CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION: {
    id: 'CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION',
    defaultMessage:
      "Remove the user from the catalog?\nThe user's Checked Out items in this catalog will be reverted and made accessible.",
  },
  CATALOG_SAVE_TEMPLATE: {
    id: 'CATALOG_SAVE_TEMPLATE',
    defaultMessage: 'Save Catalog Template...',
  },
  CATALOG_SAVE_TEMPLATE_TITLE: {
    id: 'CATALOG_SAVE_TEMPLATE_TITLE',
    defaultMessage: 'Save Catalog Template',
  },
  CATALOG_SAVE_TEMPLATE_DETAILS_TEXT: {
    id: 'CATALOG_SAVE_TEMPLATE_DETAILS_TEXT',
    defaultMessage:
      'Catalog templates include all fields, metadata mappings, and cataloging options.',
  },
  CATALOG_SELECT_MESSAGE: {
    id: 'CATALOG_SELECT_MESSAGE',
    defaultMessage: 'No Catalog Selected',
  },
  CATALOG_SET_AS_DEFAULT: {
    id: 'CATALOG_SET_AS_DEFAULT',
    defaultMessage: 'Set Default Catalog',
  },
  CATALOG_SK_DEFAULT_SETTINGS: {
    id: 'CATALOG_SK_DEFAULT_SETTINGS',
    defaultMessage: 'Default Settings',
  },
  CATALOG_SK_CONFIDENCE_LEVEL_LABEL: {
    id: 'CATALOG_SK_CONFIDENCE_LEVEL_LABEL',
    defaultMessage: 'Confidence Level',
  },
  CATALOG_SK_DEFAULT_LABEL: {
    id: 'CATALOG_SK_DEFAULT_LABEL',
    defaultMessage: 'Recommended: {recommended}',
  },
  CATALOG_SK_ENGINES_LABEL: {
    id: 'CATALOG_SK_ENGINES_LABEL',
    defaultMessage: 'Smart Keyword Engines',
  },
  CATALOG_SK_LANGUAGES_LABEL: {
    id: 'CATALOG_SK_LANGUAGES_LABEL',
    defaultMessage: 'Languages for General Engine',
  },
  CATALOG_SK_NUM_KEYWORDS_LABEL: {
    id: 'CATALOG_SK_NUM_KEYWORDS_LABEL',
    defaultMessage: 'Number of Keywords',
  },
  CATALOG_SK_SETTINGS_LABEL: {
    id: 'CATALOG_SK_SETTINGS_LABEL',
    defaultMessage: 'Settings',
  },
  CATALOG_SK_TAB_TITLE: {
    id: 'CATALOG_SK_TAB_TITLE',
    defaultMessage: 'Smart Keywords',
  },
  CATALOG_SK_USE_SK_LABEL: {
    id: 'CATALOG_SK_USE_SK_LABEL',
    defaultMessage: 'Use Smart Keywords in this Catalog',
  },
  CATALOG_SK_ON_CATALOGING_LABEL: {
    id: 'CATALOG_SK_KEYWORD_ON_CATALOG_LABEL',
    defaultMessage: 'Smart Keyword newly cataloged assets',
  },
  CATALOG_STATUS: {
    id: 'CATALOG_STATUS',
    defaultMessage: 'Catalog Status',
  },
  CATALOG_STORAGE_TYPE_LABEL: {
    id: 'CATALOG_STORAGE_TYPE_LABEL',
    defaultMessage: 'Storage Type',
  },
  CATALOG_STORAGE_TYPE_WATCHFOLDERS: {
    id: 'CATALOG_STORAGE_TYPE_WATCHFOLDERS',
    defaultMessage: 'Watch Folders',
  },
  CATALOG_STORAGE_TYPE_VAULT: {
    id: 'CATALOG_STORAGE_TYPE_VAULT',
    defaultMessage: 'Vault',
  },
  CATALOG_STORAGE_TYPE_S3: {
    id: 'CATALOG_STORAGE_TYPE_S3',
    defaultMessage: 'S3',
  },
  CATALOG_TAKE_OFFLINE_SHORT: {
    id: 'CATALOG_TAKE_OFFLINE_SHORT',
    defaultMessage: 'Take Offline',
  },
  CATALOG_TAKE_ONLINE_SHORT: {
    id: 'CATALOG_TAKE_ONLINE_SHORT',
    defaultMessage: 'Take Online',
  },
  CATALOG_TEMPLATE: {
    id: 'CATALOG_TEMPLATE',
    defaultMessage: 'template',
  },
  CATALOG_TEMPLATE_NAME: {
    id: 'CATALOG_TEMPLATE_NAME',
    defaultMessage: 'Template Name',
  },
  CATALOG_TEMPLATE_REMOVE_CONFIRMATION: {
    id: 'CATALOG_TEMPLATE_REMOVE_CONFIRMATION',
    defaultMessage: 'Remove the selected catalog template?',
  },
  CATALOG_VIEW_DETAILS: {
    id: 'CATALOG_VIEW_DETAILS',
    defaultMessage: 'View/Edit Catalog Details',
  },
  CERT_CREATE_REQUEST: {
    id: 'CERT_CREATE_REQUEST',
    defaultMessage: 'Create Certificate Request',
  },
  CERT_DELETE_CONFIRMATION: {
    id: 'CERT_DELETE_CONFIRMATION',
    defaultMessage:
      'Are you sure you want to delete the certificate request? This cannot be undone.',
  },
  CERT_DOWNLOAD: {
    id: 'CERT_DOWNLOAD',
    defaultMessage: 'Download',
  },
  CERT_EXPIRATION_DATE: {
    id: 'CERT_EXPIRATION_DATE',
    defaultMessage: 'Expiration Date',
  },
  CERT_FILE: {
    id: 'CERT_FILE',
    defaultMessage: 'Certificate File',
  },
  CERT_FILE_INT_1: {
    id: 'CERT_FILE_INT_1',
    defaultMessage: 'Intermediate Certificate 1',
  },
  CERT_FILE_INT_2: {
    id: 'CERT_FILE_INT_2',
    defaultMessage: 'Intermediate Certificate 2',
  },
  CERT_FILE_PASSWORD: {
    id: 'CERT_FILE_PASSWORD',
    defaultMessage: 'Certificate Password',
  },
  CERT_FILE_PASSWORD_HELP: {
    id: 'CERT_FILE_PASSWORD_HELP',
    defaultMessage: 'If your certificate has a password, enter it here',
  },
  CERT_FILE_PROMPT: {
    id: 'CERT_FILE_PROMPT',
    defaultMessage: 'Select...',
  },
  CERT_FILE_ROOT: {
    id: 'CERT_FILE_ROOT',
    defaultMessage: 'Root Certificate',
  },
  CERT_IMPORT: {
    id: 'CERT_IMPORT',
    defaultMessage: 'Import Certificate',
  },
  CERT_ISSUER: {
    id: 'CERT_ISSUER',
    defaultMessage: 'Issuer',
  },
  CERT_OWNER: {
    id: 'CERT_OWNER',
    defaultMessage: 'Owner',
  },
  CERT_PENDING_REQUEST: {
    id: 'CERT_PENDING_REQUEST',
    defaultMessage: 'Pending Certificate Request',
  },
  CERT_REQUEST_ALREADY_CREATED_WARNING: {
    id: 'CERT_REQUEST_ALREADY_CREATED_WARNING',
    defaultMessage:
      'You have already created a certificate request. If you continue, the existing request will be deleted.',
  },
  CERT_IMPORT_SUCCEEDED: {
    id: 'CERT_IMPORT_SUCCEEDED',
    defaultMessage:
      'The certificate was successfully imported. Please restart the Portfolio server and Portfolio admin services to begin using the certificate.',
  },
  CERT_IMPORT_FAILED_READING_PKCS12: {
    id: 'CERT_IMPORT_FAILED_READING_PKCS12',
    defaultMessage:
      'The server could not read the PKCS12 certificate. Check the password.',
  },
  CERT_IMPORT_FAILED_INTERMEDIATE1: {
    id: 'CERT_IMPORT_FAILED_INTERMEDIATE1',
    defaultMessage: 'The Intermediate 1 certificate could not be imported.',
  },
  CERT_IMPORT_FAILED_INTERMEDIATE2: {
    id: 'CERT_IMPORT_FAILED_INTERMEDIATE2',
    defaultMessage: 'The Intermediate 2 certificate could not be imported.',
  },
  CERT_IMPORT_FAILED_ROOT: {
    id: 'CERT_IMPORT_FAILED_ROOT',
    defaultMessage: 'The root certificate could not be imported.',
  },
  CERTIFICATE_FILE_FILTER: {
    id: 'CERTIFICATE_FILE_FILTER',
    defaultMessage: 'Certificates (p7b, cer, crt, der, pfx, p12)',
  },
  CERTIFICATE_STATUS_INVALID: {
    id: 'CERTIFICATE_STATUS_INVALID',
    defaultMessage: 'Invalid Certificate',
  },
  CERTIFICATE_STATUS_SELF_SIGNED: {
    id: 'CERTIFICATE_STATUS_SELF_SIGNED',
    defaultMessage: 'Invalid Certificate: Self-Signed',
  },
  CERTIFICATE_STATUS_EXPIRED: {
    id: 'CERTIFICATE_STATUS_EXPIRED',
    defaultMessage: 'Certificate Expired',
  },
  CERTIFICATE_STATUS_IMPORTED: {
    id: 'CERTIFICATE_STATUS_IMPORTED',
    defaultMessage: 'Certificate Imported',
  },
  CERTS_TITLE: {
    id: 'CERTS_TITLE',
    defaultMessage: 'SSL Certificate',
  },
  CHANGE: {
    id: 'CHANGE',
    defaultMessage: 'Change',
  },
  CITY_OR_LOCALITY: {
    id: 'CITY_OR_LOCALITY',
    defaultMessage: 'City or Locality',
  },
  CLEAR_BUTTON_LABEL: {
    id: 'CLEAR_BUTTON_LABEL',
    defaultMessage: 'Clear',
  },
  COMMUNICATION_AT_INITILIZATION_ERROR: {
    id: 'COMMUNICATION_AT_INITILIZATION_ERROR',
    defaultMessage:
      'There was an error communicating with the server. This is usually caused by stale data in the browser cache but it could also indicate a problem with the server. Contact your administrator for more information.',
  },
  CONFIGURE_DIRECTORY_SERVICE: {
    id: 'CONFIGURE_DIRECTORY_SERVICE',
    defaultMessage: 'Configure Directory Service',
  },
  CONFIGURE_EMAIL_LINK: {
    id: 'CONFIGURE_EMAIL_LINK',
    defaultMessage: 'Configure email notifications...',
  },
  CONFIRM_DELETE_PDL: {
    id: 'CONFIRM_DELETE_PDL',
    defaultMessage: 'Delete all predefined values for this field?',
  },
  CONFIRM_DELETE_SERVICE: {
    id: 'CONFIRM_DELETE_SERVICE',
    defaultMessage:
      'Remove Directory Service?\nUsers imported from the service will remain. Their passwords will revert to values set previously in Portfolio, or will be disabled if not set previously.',
  },
  CONFIRM_TRUNCATE_VALUES: {
    id: 'CONFIRM_TRUNCATE_VALUES',
    defaultMessage:
      'Max Length exceeds one or more default or predefined values for this field. Truncate values?',
  },
  CONNECTION_REFUSED_ERROR: {
    id: 'CONNECTION_REFUSED_ERROR',
    defaultMessage:
      'The connection to the directory service was refused. Please check your hostname and port settings.',
  },
  CONTAINS: {
    id: 'CONTAINS',
    defaultMessage: 'contains',
  },
  CONTINUE: {
    id: 'CONTINUE',
    defaultMessage: 'Continue',
  },
  CREATE: {
    id: 'CREATE',
    defaultMessage: 'Create',
  },
  CREATE_A_CERTIFICATE_REQUEST: {
    id: 'CREATE_A_CERTIFICATE_REQUEST',
    defaultMessage: 'Create a certificate signing request',
  },
  CREATE_CATALOG: {
    id: 'CREATE_CATALOG',
    defaultMessage: 'Create Catalog',
  },
  createContactSheet: {
    id: 'createContactSheet',
    defaultMessage: 'Make PDF',
  },
  CREATE_USER: {
    id: 'CREATE_USER',
    defaultMessage: 'Create User',
  },
  CREATED_BY: {
    id: 'CREATED_BY',
    defaultMessage: 'Created By',
  },
  CREATE_MAPPING: {
    id: 'CREATE_MAPPING',
    defaultMessage: 'Create Mapping',
  },
  CREATE_USER_EXCLUSION_MAPPING: {
    id: 'CREATE_USER_EXCLUSION_MAPPING',
    defaultMessage: 'Exclude User',
  },
  CREATED_ON_DATE: {
    id: 'CREATED_ON_DATE',
    defaultMessage: 'Date Created',
  },
  DATE_FORMAT: {
    id: 'DATE_FORMAT',
    defaultMessage: 'MM/DD/YYYY',
  },
  DATE_FORMAT_ERROR: {
    id: 'DATE_FORMAT_ERROR',
    defaultMessage: 'Configuration error: Incorrect formatting string.',
  },
  DATE_INVALID_CHAR_ERROR: {
    id: 'DATE_INVALID_CHAR_ERROR',
    defaultMessage: 'The date contains invalid characters.',
  },
  DATE_TIME_FORMAT: {
    id: 'DATE_TIME_FORMAT',
    defaultMessage: 'MM/DD/YYYY L:NN A',
  },
  DATE_TIME_SECONDS_FORMAT: {
    id: 'DATE_TIME_SECONDS_FORMAT',
    defaultMessage: 'MM/DD/YYYY L:NN:SS A',
  },
  DATE_WRONG_DAY_ERROR: {
    id: 'DATE_WRONG_DAY_ERROR',
    defaultMessage: 'Enter a valid day for the month.',
  },
  DATE_WRONG_LENGTH_ERROR: {
    id: 'DATE_WRONG_LENGTH_ERROR',
    defaultMessage: 'Type the date in the format:',
  },
  DATE_WRONG_MONTH_ERROR: {
    id: 'DATE_WRONG_MONTH_ERROR',
    defaultMessage: 'Enter a month between 1 and 12.',
  },
  DATE_WRONG_YEAR_ERROR: {
    id: 'DATE_WRONG_YEAR_ERROR',
    defaultMessage: 'Enter a year between 0 and 9999.',
  },
  DEFAULT_ACCESS_LEVEL: {
    id: 'DEFAULT_ACCESS_LEVEL',
    defaultMessage: 'Default Role',
  },
  DEFAULT_CATALOG: {
    id: 'DEFAULT_CATALOG',
    defaultMessage: 'Default Catalog',
  },
  DEFAULT_CATALOG_NONE: {
    id: 'DEFAULT_CATALOG_NONE',
    defaultMessage: 'None',
  },
  DEFAULT_PORT_NON_SSL: {
    id: 'DEFAULT_PORT_NON_SSL',
    defaultMessage: 'Default port for non-SSL:',
  },
  DEFAULT_PORT_SSL: {
    id: 'DEFAULT_PORT_SSL',
    defaultMessage: 'Default port for SSL:',
  },
  DELETE: {
    id: 'DELETE',
    defaultMessage: 'Delete',
  },
  deleteAssetContents: {
    id: 'deleteAssetContents',
    defaultMessage: 'Delete Original Assets',
  },
  deleteAssetFromCatalog: {
    id: 'deleteAssetFromCatalog',
    defaultMessage: 'Delete Asset from Catalog',
  },
  DELETE_SOURCE: {
    id: 'DELETE_SOURCE',
    defaultMessage: 'Delete Source',
  },
  DELETE_ALL_NESTED_VALUES_CONFIRMATION: {
    id: 'DELETE_ALL_NESTED_VALUES_CONFIRMATION',
    defaultMessage:
      'Delete all values?\nThis will delete all values including nested values.',
  },
  DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION: {
    id: 'DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION',
    defaultMessage:
      "Delete the value '{value}'?\nIt contains nested values which will also be deleted.",
  },
  DELETE_NESTED_VALUE_CONFIRMATION: {
    id: 'DELETE_NESTED_VALUE_CONFIRMATION',
    defaultMessage:
      'Delete the selected values?\nThey contain nested values which will also be deleted.',
  },
  DELETE_WARNING_BOX_MSG: {
    id: 'DELETE_WARNING_BOX_MSG',
    defaultMessage: 'Warning! Deleting cannot be undone!',
  },
  DELETE_WARNING_CATALOG_VAULT: {
    id: 'DELETE_WARNING_CATALOG_VAULT',
    defaultMessage: 'All files in the catalog will be destroyed.',
  },
  DIAGNOSTICS_TITLE: {
    id: 'DIAGNOSTICS_TITLE',
    defaultMessage: 'Diagnostics',
  },
  DIAGNOSTICS_NO_PROBLEMS: {
    id: 'DIAGNOSTICS_NO_PROBLEMS',
    defaultMessage: 'No problems found',
  },
  DIAGNOSTIC_DATA_TITLE: {
    id: 'DIAGNOSTIC_DATA_TITLE',
    defaultMessage: 'Send Diagnostic Report to Extensis',
  },
  DIAGNOSTIC_DATA_ACCOUNT_NAME: {
    id: 'DIAGNOSTIC_DATA_ACCOUNT_NAME',
    defaultMessage: 'Company or Account Name (Required)',
  },
  DIAGNOSTIC_DATA_CONTACT_NAME: {
    id: 'DIAGNOSTIC_DATA_CONTACT_NAME',
    defaultMessage: 'Contact Name',
  },
  DIAGNOSTIC_DATA_TS_TICKET_NUMBER: {
    id: 'DIAGNOSTIC_DATA_TS_TICKET_NUMBER',
    defaultMessage: 'Tech Support Ticket Number',
  },
  DIAGNOSTIC_DATA_SEND_REPORT_BUTTON: {
    id: 'DIAGNOSTIC_DATA_SEND_REPORT_BUTTON',
    defaultMessage: 'Send Report',
  },
  DIAGNOSTIC_STATUS_ERROR: {
    id: 'DIAGNOSTIC_STATUS_ERROR',
    defaultMessage:
      'There was a problem uploading the diagnostic report on {date}',
  },
  DIAGNOSTIC_STATUS_SENDING: {
    id: 'DIAGNOSTIC_STATUS_SENDING',
    defaultMessage: 'Sending...',
  },
  DIAGNOSTIC_STATUS_SUCCESS: {
    id: 'DIAGNOSTIC_STATUS_SUCCESS',
    defaultMessage: 'Diagnostic report successfully sent to Extensis on {date}',
  },
  DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE: {
    id: 'DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE',
    defaultMessage: 'Querying\nThis may take a few minutes...',
  },
  DIRECTORY_SERVICE_CONNECT_ERROR: {
    id: 'DIRECTORY_SERVICE_CONNECT_ERROR',
    defaultMessage:
      'Unable to connect to the directory service. Please check the hostname and port settings.',
  },
  DIRECTORY_SERVICE_BROWSE_FILTER_LABEL: {
    id: 'DIRECTORY_SERVICE_BROWSE_FILTER_LABEL',
    defaultMessage: 'Filter',
  },
  DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL: {
    id: 'DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL',
    defaultMessage: 'AD Users and Groups',
  },
  DIRECTORY_SERVICE_CONFIG_TITLE: {
    id: 'DIRECTORY_SERVICE_CONFIG_TITLE',
    defaultMessage: 'Active Directory Configuration',
  },
  DIRECTORY_SERVICES_TITLE: {
    id: 'DIRECTORY_SERVICES_TITLE',
    defaultMessage: 'Directory Services',
  },
  DIRECTORY_SERVICE_SAVE_MAPPINGS: {
    id: 'DIRECTORY_SERVICE_SAVE_MAPPINGS',
    defaultMessage: 'Save and Sync',
  },
  DIRECTORY_SERVICE_REMOVE_MAPPING: {
    id: 'DIRECTORY_SERVICE_REMOVE_MAPPING',
    defaultMessage: 'Remove Mapping',
  },
  DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL: {
    id: 'DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL',
    defaultMessage: 'Portfolio User Imports',
  },
  DIRECTORY_SERVICE_MAPIINGS: {
    id: 'DIRECTORY_SERVICE_MAPIINGS',
    defaultMessage: 'Directory Items to Portfolio Mappings',
  },
  DIRECTORY_SERVICE_MAPIINGS_TITLE: {
    id: 'DIRECTORY_SERVICE_MAPIINGS_TITLE',
    defaultMessage: 'Mappings',
  },
  DIRECTORY_SERVICE_NO_MAPPINGS_LABEL: {
    id: 'DIRECTORY_SERVICE_NO_MAPPINGS_LABEL',
    defaultMessage:
      "No Mappings\n\nTo create a mapping, select a user or group to the left, and click 'Create Mapping'",
  },
  DIRECTORY_SERVICES: {
    id: 'DIRECTORY_SERVICES',
    defaultMessage: 'Directory Services',
  },
  DIRECTORY_USERS_CANNOT_BE_DELETED: {
    id: 'DIRECTORY_USERS_CANNOT_BE_DELETED',
    defaultMessage: 'Directory Service users cannot be deleted!',
  },
  DISTRIBUTION_GROUPS: {
    id: 'DISTRIBUTION_GROUPS',
    defaultMessage: 'Distribution Groups',
  },
  DOWNLOAD_CERT_PROMPT: {
    id: 'DOWNLOAD_CERT_PROMPT',
    defaultMessage: 'Download certificate request file?',
  },
  DOWNLOAD_COMPLETE_STRING: {
    id: 'DOWNLOAD_COMPLETE_STRING',
    defaultMessage: 'Download complete.',
  },
  downloadPreviews: {
    id: 'downloadPreviews',
    defaultMessage: 'Download Previews',
  },
  EMAIL_ADDRESS: {
    id: 'EMAIL_ADDRESS',
    defaultMessage: 'Email Address',
  },
  EMAIL_CONFIG_AUTH_PASSWORD: {
    id: 'EMAIL_CONFIG_AUTH_PASSWORD',
    defaultMessage: 'Password',
  },
  EMAIL_CONFIG_AUTH_USERNAME: {
    id: 'EMAIL_CONFIG_AUTH_USERNAME',
    defaultMessage: 'User Name',
  },
  EMAIL_CONFIG_ENABLED: {
    id: 'EMAIL_CONFIG_ENABLED',
    defaultMessage: 'Enable Email Notifications',
  },
  EMAIL_CONFIG_FROM_ADDRESS: {
    id: 'EMAIL_CONFIG_FROM_ADDRESS',
    defaultMessage: 'Email From Address',
  },
  EMAIL_CONFIG_INVALID_GENERIC: {
    id: 'EMAIL_CONFIG_INVALID_GENERIC',
    defaultMessage: 'Email Server Configuration Invalid',
  },
  EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND: {
    id: 'EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND',
    defaultMessage: 'Email Server Not Found',
  },
  EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED: {
    id: 'EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED',
    defaultMessage: 'Email Server Authentication Failed',
  },
  EMAIL_CONFIG_MESSAGE: {
    id: 'EMAIL_CONFIG_MESSAGE',
    defaultMessage:
      'Each user who wishes to receive notifications must have an email address assigned in the Users pane.',
  },
  EMAIL_CONFIG_SERVER_ADDRESS: {
    id: 'EMAIL_CONFIG_SERVER_ADDRESS',
    defaultMessage: 'SMTP Server Address',
  },
  EMAIL_CONFIG_SERVER_PORT: {
    id: 'EMAIL_CONFIG_SERVER_PORT',
    defaultMessage: 'SMTP Server Port',
  },
  EMAIL_CONFIG_SUCCESS_MESSAGE: {
    id: 'EMAIL_CONFIG_SUCCESS_MESSAGE',
    defaultMessage: 'SMTP Server Validated',
  },
  EMAIL_CONFIG_USE_SSL_TLS: {
    id: 'EMAIL_CONFIG_USE_SSL_TLS',
    defaultMessage: 'Use SSL / TLS',
  },
  EMAIL_CONFIG_USE_SMTP_AUTH: {
    id: 'EMAIL_CONFIG_USE_SMTP_AUTH',
    defaultMessage: 'Use SMTP Authentication',
  },
  EMAIL_CONFIG_VALIDATE: {
    id: 'EMAIL_CONFIG_VALIDATE',
    defaultMessage: 'Test Connection',
  },
  EMAIL_CONFIG_VALIDATED: {
    id: 'EMAIL_CONFIG_VALIDATED',
    defaultMessage: 'Email Server Validated',
  },
  english: {
    id: 'english',
    defaultMessage: 'English',
  },
  ENTIRE_TREE_UNDER_SEARCH_BASE: {
    id: 'ENTIRE_TREE_UNDER_SEARCH_BASE',
    defaultMessage: 'Entire tree',
  },
  EQUALS: {
    id: 'EQUALS',
    defaultMessage: 'equals',
  },
  ESP_PORT_ADMIN_WEB_APP: {
    id: 'esp.port.admin-web-app',
    defaultMessage: 'Portfolio Admin HTTP Port',
  },
  ESP_PORT_ADMIN_WEB_APP_SSL: {
    id: 'esp.port.admin-web-app-ssl',
    defaultMessage: 'Portfolio Admin SSL Port',
  },
  ESP_PORT_HTTP: {
    id: 'esp.port.http',
    defaultMessage: 'Portfolio Server HTTP Port',
  },
  ESP_PORT_SSL: {
    id: 'esp.port.ssl',
    defaultMessage: 'Portfolio Server SSL Port',
  },
  EXPORT_MENU_STRING: {
    id: 'EXPORT_MENU_STRING',
    defaultMessage: 'Export Values',
  },
  FADEL_HOWTO: {
    id: 'FADEL_HOWTO',
    defaultMessage: 'Login to your FADEL account:',
  },
  FALSE_LABEL: {
    id: 'FALSE_LABEL',
    defaultMessage: 'False',
  },
  FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR: {
    id: 'FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR',
    defaultMessage:
      'Please check that the admin server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload this application.',
  },
  FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS: {
    id: 'FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS',
    defaultMessage:
      'This operation cannot be performed while a backup or restore is in progress.',
  },
  FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE: {
    id: 'FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE',
    defaultMessage:
      'That operation failed because the catalog is in admin mode.',
  },
  FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME: {
    id: 'FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME',
    defaultMessage: 'A catalog already exists with this name.',
  },
  FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME: {
    id: 'FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME',
    defaultMessage: 'A user already exists with this account name.',
  },
  FAULT_MSG_DB_IN_USE: {
    id: 'FAULT_MSG_DB_IN_USE',
    defaultMessage:
      'The operation could not be completed because the catalog is currently in use by an administrator.',
  },
  FAULT_MSG_DELETE_ADMIN: {
    id: 'FAULT_MSG_DELETE_ADMIN',
    defaultMessage: 'You cannot delete the administrator account.',
  },
  FAULT_MSG_DELETE_SELF: {
    id: 'FAULT_MSG_DELETE_SELF',
    defaultMessage: 'You cannot delete your user account.',
  },
  FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR: {
    id: 'FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR',
    defaultMessage:
      'An unexpected error occurred when deleting the catalog template.',
  },
  FAULT_MSG_DUPE_NAME: {
    id: 'FAULT_MSG_DUPE_NAME',
    defaultMessage:
      'An object with that name already exists.  Please use another name.',
  },
  FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS: {
    id: 'FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS',
    defaultMessage:
      'There is already a Media Engine with that address and port.',
  },
  FAULT_MSG_ENTITY_VERSION_MISMATCH: {
    id: 'FAULT_MSG_ENTITY_VERSION_MISMATCH',
    defaultMessage:
      " That operation failed because the client's information was out of date.",
  },
  FAULT_MSG_IDENT_SERVICE_CREATION_ERROR: {
    id: 'FAULT_MSG_IDENT_SERVICE_CREATION_ERROR',
    defaultMessage:
      'Please check that the server is running on your local machine on the port reflected on the ports page. If not, restart the server and reload the application.',
  },
  FAULT_MSG_INVALID_SESSION_ID: {
    id: 'FAULT_MSG_INVALID_SESSION_ID',
    defaultMessage:
      'Your session has expired. You must log into the server again.',
  },
  FAULT_MSG_IS_NOT_LICENSED: {
    id: 'FAULT_MSG_IS_NOT_LICENSED',
    defaultMessage: 'Server not licensed for that operation.',
  },
  FAULT_MSG_LEGACY_21000: {
    id: 'FAULT_MSG_LEGACY_21000',
    defaultMessage:
      'The operation failed because of an unknown internal error.',
  },
  FAULT_MSG_LOGGING_ERR_UPDATE: {
    id: 'FAULT_MSG_LOGGING_ERR_UPDATE',
    defaultMessage:
      'There has been an error updating the logging configuration',
  },
  FAULT_MSG_LOG_DIR_NOT_VALID: {
    id: 'FAULT_MSG_LOG_DIR_NOT_VALID',
    defaultMessage:
      'The specified log directory does not exist, is not writeable or the path specified is not a directory.',
  },
  FAULT_MSG_NO_DIRECTORY: {
    id: 'FAULT_MSG_NO_DIRECTORY',
    defaultMessage:
      'The specified location does not exist or it is not a directory.',
  },
  FAULT_MSG_NULL_DESCRIPTION: {
    id: 'FAULT_MSG_NULL_DESCRIPTION',
    defaultMessage:
      'An unexpected error occurred, but there is no description to report.',
  },
  FAULT_MSG_NULL_FAULTEVENT: {
    id: 'FAULT_MSG_NULL_FAULTEVENT',
    defaultMessage:
      'An unexpected error occurred, but there are no details to report.',
  },
  FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES: {
    id: 'FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES',
    defaultMessage:
      'That operation failed because you do not have sufficient privileges.',
  },
  FAULT_MSG_OPERATION_IS_INVALID: {
    id: 'FAULT_MSG_OPERATION_IS_INVALID',
    defaultMessage: 'That operation was not valid.',
  },
  FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR: {
    id: 'FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR',
    defaultMessage:
      'An unexpected error occurred when renaming the catalog template.',
  },
  FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR: {
    id: 'FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR',
    defaultMessage:
      'An unexpected error occurred when saving the catalog template.',
  },
  FAULT_MSG_SERVER_NOT_RUNNING: {
    id: 'FAULT_MSG_SERVER_NOT_RUNNING',
    defaultMessage: 'The server is not running.',
  },
  FAULT_MSG_ENTERPRISE_NOT_LICENSED: {
    id: 'FAULT_MSG_ENTERPRISE_NOT_LICENSED',
    defaultMessage:
      'The operation failed because the server does not have an Enterprise Module license.',
  },
  FAULT_MSG_REMOVE_METADATA_DEF: {
    id: 'FAULT_MSG_REMOVE_METADATA_DEF',
    defaultMessage:
      'Removing the metadata definition failed.  It may be in use by other catalogs.',
  },
  FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT: {
    id: 'FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT',
    defaultMessage: 'The server returned a fault with this message: ',
  },
  FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE: {
    id: 'FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE',
    defaultMessage: 'The server returned a fault with no error message. ',
  },
  FAULT_MSG_UNHANDLED_UNKNOWN_FAULT: {
    id: 'FAULT_MSG_UNHANDLED_UNKNOWN_FAULT',
    defaultMessage:
      'The server returned a fault with an unknown type and this message:',
  },
  FAULT_MSG_UNKNOWN_SMTP_SERVER: {
    id: 'FAULT_MSG_UNKNOWN_SMTP_SERVER',
    defaultMessage: 'Unable to connect to the specified mail server.',
  },
  FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING: {
    id: 'FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING',
    defaultMessage:
      'That operation failed because a service was not in the expected state.',
  },
  FAULT_MSG_INVALID_LOGINID_OR_PASSWORD: {
    id: 'FAULT_MSG_INVALID_LOGINID_OR_PASSWORD',
    defaultMessage:
      'The username or password supplied for the database is not valid.',
  },
  FAULT_MSG_BAD_DB_PORT: {
    id: 'FAULT_MSG_BAD_DB_PORT',
    defaultMessage: 'The database port specified is not valid.',
  },
  FAULT_MSG_BAD_DB_HOST: {
    id: 'FAULT_MSG_BAD_DB_HOST',
    defaultMessage: 'The database hostname or port specified is invalid.',
  },
  FIELD_ACTION_ADD: {
    id: 'FIELD_ACTION_ADD',
    defaultMessage: 'Add New Custom Field',
  },
  FIELD_ACTION_DELETE: {
    id: 'FIELD_ACTION_DELETE',
    defaultMessage: 'Delete Selected Field',
  },
  FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES: {
    id: 'FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES',
    defaultMessage: 'XMP Namespaces',
  },
  FIELD_ACTION_MANAGE_METADATA: {
    id: 'FIELD_ACTION_MANAGE_METADATA',
    defaultMessage: 'Manage Metadata',
  },
  FIELD_ADD_EXTRACT_METADATA: {
    id: 'FIELD_ADD_EXTRACT_METADATA',
    defaultMessage: 'Add Extract Metadata',
  },
  FIELD_CATEGORY_ALL: {
    id: 'FIELD_CATEGORY_ALL',
    defaultMessage: 'All Active Fields',
  },
  FIELD_CATEGORY_CUSTOM: {
    id: 'FIELD_CATEGORY_CUSTOM',
    defaultMessage: 'Custom Fields',
  },
  FIELD_CATEGORY_SYSTEM: {
    id: 'FIELD_CATEGORY_SYSTEM',
    defaultMessage: 'System Fields',
  },
  FIELD_CATEGORY_EXIF: {
    id: 'FIELD_CATEGORY_EXIF',
    defaultMessage: 'EXIF',
  },
  FIELD_CATEGORY_IPTC: {
    id: 'FIELD_CATEGORY_IPTC',
    defaultMessage: 'IPTC',
  },
  FIELD_CATEGORY_XMP: {
    id: 'FIELD_CATEGORY_XMP',
    defaultMessage: 'XMP',
  },
  FIELD_CATEGORY_MOVIE: {
    id: 'FIELD_CATEGORY_MOVIE',
    defaultMessage: 'Movie',
  },
  FIELD_CATEGORY_OFFICE: {
    id: 'FIELD_CATEGORY_OFFICE',
    defaultMessage: 'MS Office',
  },
  FIELD_CATEGORY_GEO: {
    id: 'FIELD_CATEGORY_GEO',
    defaultMessage: 'GEO',
  },
  FIELD_CATEGORY_LABEL: {
    id: 'FIELD_CATEGORY_LABEL',
    defaultMessage: 'Field Category',
  },
  FIELD_CATEGORY_FONTSENSE: {
    id: 'FIELD_CATEGORY_FONTSENSE',
    defaultMessage: 'Extensis Font Sense',
  },
  FIELD_DELETE_CONFIRM_MSG: {
    id: 'FIELD_DELETE_CONFIRM_MSG',
    defaultMessage: 'Do you want to delete the selected field?',
  },
  FIELD_DISABLE_CONFIRM_MSG: {
    id: 'FIELD_DISABLE_CONFIRM_MSG',
    defaultMessage: 'Do you want to disable the selected field?',
  },
  FIELD_ENABLE_ALL_CATEGORIES_LABEL: {
    id: 'FIELD_ENABLE_ALL_CATEGORIES_LABEL',
    defaultMessage: 'Enable All',
  },
  FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING: {
    id: 'FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING',
    defaultMessage: 'Add Extract Mapping',
  },
  FIELD_FORM_LABEL_DEFAULT_VALUE: {
    id: 'FIELD_FORM_LABEL_DEFAULT_VALUE',
    defaultMessage: 'Default Value',
  },
  FIELD_FORM_LABEL_DISABLED: {
    id: 'FIELD_FORM_LABEL_DISABLED',
    defaultMessage: '(Disabled)',
  },
  FIELD_FORM_LABEL_EMBED: {
    id: 'FIELD_FORM_LABEL_EMBED',
    defaultMessage: 'Embed in Metadata',
  },
  FIELD_FORM_LABEL_EXTRACT: {
    id: 'FIELD_FORM_LABEL_EXTRACT',
    defaultMessage: 'Extract from Metadata',
  },
  FIELD_FORM_LABEL_FIELD_NAME: {
    id: 'FIELD_FORM_LABEL_FIELD_NAME',
    defaultMessage: 'Field Name',
  },
  FIELD_FORM_LABEL_FIELD_TYPE: {
    id: 'FIELD_FORM_LABEL_FIELD_TYPE',
    defaultMessage: 'Field Type',
  },
  FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES: {
    id: 'FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES',
    defaultMessage: 'Allow Multiple Values',
  },
  FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES: {
    id: 'FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES',
    defaultMessage: 'Has Predefined Values',
  },
  FIELD_FORM_LABEL_HELP_TEXT: {
    id: 'FIELD_FORM_LABEL_HELP_TEXT',
    defaultMessage: 'Help Text',
  },
  FIELD_FORM_LABEL_MAX: {
    id: 'FIELD_FORM_LABEL_MAX',
    defaultMessage: 'Max: {max}',
  },
  FIELD_FORM_LABEL_MAX_LENGTH: {
    id: 'FIELD_FORM_LABEL_MAX_LENGTH',
    defaultMessage: 'Max Length',
  },
  FIELD_FORM_LABEL_METADATA_TAG: {
    id: 'FIELD_FORM_LABEL_METADATA_TAG',
    defaultMessage: 'Metadata Name',
  },
  FIELD_FORM_LABEL_METADATA_TYPE: {
    id: 'FIELD_FORM_LABEL_METADATA_TYPE',
    defaultMessage: 'Metadata Type',
  },
  FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES: {
    id: 'FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES',
    defaultMessage: 'Allow Only Predefined Values',
  },
  FIELD_FORM_LABEL_PRECISION: {
    id: 'FIELD_FORM_LABEL_PRECISION',
    defaultMessage: 'Precision',
  },
  FIELD_FORM_LABEL_PRECISION_MAX: {
    id: 'FIELD_FORM_LABEL_PRECISION_MAX',
    defaultMessage: 'Max',
  },
  FIELD_FORM_LABEL_PREDEFINED_VALUES: {
    id: 'FIELD_FORM_LABEL_PREDEFINED_VALUES',
    defaultMessage: 'Predefined Values',
  },
  FIELD_FORM_LABEL_SHOW_TIME: {
    id: 'FIELD_FORM_LABEL_SHOW_TIME',
    defaultMessage: 'Show Time',
  },
  FIELD_FORM_LABEL_USE_METADATA: {
    id: 'FIELD_FORM_LABEL_USE_METADATA',
    defaultMessage: 'Extract and Embed Metadata',
  },
  FIELD_FORM_WARNING_DUPE_EMBEDS: {
    id: 'FIELD_FORM_WARNING_DUPE_EMBEDS',
    defaultMessage: "Warning: More than one field embeds to '{metadata}'",
  },
  FIELD_METADATA_DATA_TYPE_LABEL: {
    id: 'FIELD_METADATA_DATA_TYPE_LABEL',
    defaultMessage: 'Data Type',
  },
  FIELD_METADATA_DEFINITION_IS_CUSTOM: {
    id: 'FIELD_METADATA_DEFINITION_IS_CUSTOM',
    defaultMessage: 'Is Custom',
  },
  FIELD_METADATA_DEFINITIONS_TITLE: {
    id: 'FIELD_METADATA_DEFINITIONS_TITLE',
    defaultMessage: 'Metadata Definitions',
  },
  FIELD_METADATA_DELETE_CONFIRM_MSG: {
    id: 'FIELD_METADATA_DELETE_CONFIRM_MSG',
    defaultMessage: 'Confirm: Delete the Metadata Definition?',
  },
  FIELD_METADATA_MULTIVALUED_TYPE_LABEL: {
    id: 'FIELD_METADATA_MULTIVALUED_TYPE_LABEL',
    defaultMessage: 'Multivalued Type',
  },
  FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL: {
    id: 'FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL',
    defaultMessage: 'Not Multivalued',
  },
  FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL: {
    id: 'FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL',
    defaultMessage: 'Ordered',
  },
  FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL: {
    id: 'FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL',
    defaultMessage: 'Unordered',
  },
  FIELD_METADATA_NAME_LABEL: {
    id: 'FIELD_METADATA_NAME_LABEL',
    defaultMessage: 'Name',
  },
  FIELD_METADATA_NAMESPACE_LABEL: {
    id: 'FIELD_METADATA_NAMESPACE_LABEL',
    defaultMessage: 'Namespace',
  },
  FIELD_METADATA_NEW_NAMESPACE_TOOLTIP: {
    id: 'FIELD_METADATA_NEW_NAMESPACE_TOOLTIP',
    defaultMessage: 'Add a Custom XMP Namespace...',
  },
  FIELD_METADATA_TAG_LABEL: {
    id: 'FIELD_METADATA_TAG_LABEL',
    defaultMessage: 'Tag',
  },
  FIELD_METADATA_TYPE_LABEL: {
    id: 'FIELD_METADATA_TYPE_LABEL',
    defaultMessage: 'Type',
  },
  FIELD_MULTIPLE_EMBED_WARNING: {
    id: 'FIELD_MULTIPLE_EMBED_WARNING',
    defaultMessage: 'More than one field embeds to',
  },
  FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE: {
    id: 'FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE',
    defaultMessage: 'Multiple Fields Selected',
  },
  FIELD_NAMESPACE_ABBREVIATION: {
    id: 'FIELD_NAMESPACE_ABBREVIATION',
    defaultMessage: 'Abbreviation',
  },
  FIELD_NAMESPACE_REMOVE_CONFIRMATION: {
    id: 'FIELD_NAMESPACE_REMOVE_CONFIRMATION',
    defaultMessage:
      'Delete the Custom XMP Namespace?\nThere may be Field Definitions using the namespace.',
  },
  FIELD_NAMESPACE_URI: {
    id: 'FIELD_NAMESPACE_URI',
    defaultMessage: 'Namespace URI',
  },
  FIELD_NEW_FIELD_NAME: {
    id: 'FIELD_NEW_FIELD_NAME',
    defaultMessage: 'New Field',
  },
  FIELD_NEW_METADATA_TITLE: {
    id: 'FIELD_NEW_METADATA_TITLE',
    defaultMessage: 'New Metadata Definition',
  },
  FIELD_NEW_NAMESPACE_TITLE: {
    id: 'FIELD_NEW_NAMESPACE_TITLE',
    defaultMessage: 'New Custom XMP Namespace',
  },
  FIELD_NO_FIELD_SELECTED_MESSAGE: {
    id: 'FIELD_NO_FIELD_SELECTED_MESSAGE',
    defaultMessage: 'No Field Selected',
  },
  FIELD_PAGE_TITLE: {
    id: 'FIELD_PAGE_TITLE',
    defaultMessage: "Manage Fields for Catalog '{catalogName}'",
  },
  FIELD_REVERT_CONFIRM_MSG: {
    id: 'FIELD_REVERT_CONFIRM_MSG',
    defaultMessage: 'Confirm: Revert the field?',
  },
  FIELD_TYPE_BLOB: {
    id: 'FIELD_TYPE_BLOB',
    defaultMessage: 'Blob',
  },
  FIELD_TYPE_BOOLEAN: {
    id: 'FIELD_TYPE_BOOLEAN',
    defaultMessage: 'Boolean',
  },
  FIELD_TYPE_DATETIME: {
    id: 'FIELD_TYPE_DATETIME',
    defaultMessage: 'Date/Time',
  },
  FIELD_TYPE_DECIMAL: {
    id: 'FIELD_TYPE_DECIMAL',
    defaultMessage: 'Decimal',
  },
  FIELD_TYPE_LANG_ALT: {
    id: 'FIELD_TYPE_LANG_ALT',
    defaultMessage: 'Lang Alt',
  },
  FIELD_TYPE_NUMBER: {
    id: 'FIELD_TYPE_NUMBER',
    defaultMessage: 'Number',
  },
  FIELD_TYPE_PICTURE: {
    id: 'FIELD_TYPE_PICTURE',
    defaultMessage: 'Picture',
  },
  FIELD_TYPE_STRING: {
    id: 'FIELD_TYPE_STRING',
    defaultMessage: 'String',
  },
  FIELD_TYPE_STRUCTURE: {
    id: 'FIELD_TYPE_STRUCTURE',
    defaultMessage: 'Structure',
  },
  FIELD_TYPE_TEXTBLOCK: {
    id: 'FIELD_TYPE_TEXTBLOCK',
    defaultMessage: 'Text Block',
  },
  FIELD_TYPE_UNKNOWN: {
    id: 'FIELD_TYPE_UNKNOWN',
    defaultMessage: 'Unknown',
  },
  FIELD_TYPE_URL: {
    id: 'FIELD_TYPE_URL',
    defaultMessage: 'URL',
  },
  FILE_IO_ERROR_MSG: {
    id: 'FILE_IO_ERROR_MSG',
    defaultMessage: 'There was an error uploading the file to the server.',
  },
  FILE_TYPES_SECTION_TITLE: {
    id: 'FILE_TYPES_SECTION_TITLE',
    defaultMessage: 'File Types',
  },
  FILE_TYPES_ERROR_NAME_EXISTS: {
    id: 'FILE_TYPES_ERROR_NAME_EXISTS',
    defaultMessage:
      "The name '{name}' matches the name of an existing file type.",
  },
  FILE_TYPES_LABEL_RESTORE_DEFAULTS: {
    id: 'FILE_TYPES_LABEL_RESTORE_DEFAULTS',
    defaultMessage: 'Reset Defaults',
  },
  FILE_TYPES_PROMPT_DISCARD_CHANGES: {
    id: 'FILE_TYPES_PROMPT_DISCARD_CHANGES',
    defaultMessage: 'Discard pending changes?',
  },
  FILE_TYPES_PROMPT_RESTORE_DEFAULTS: {
    id: 'FILE_TYPES_PROMPT_RESTORE_DEFAULTS',
    defaultMessage: 'Reset all FileTypes to their default values?',
  },
  FILE_TYPES_ADD_FILE_TYPE: {
    id: 'FILE_TYPES_ADD_FILE_TYPE',
    defaultMessage: 'Add File Type',
  },
  FILE_TYPES_UPDATE_FILE_TYPE: {
    id: 'FILE_TYPES_UPDATE_FILE_TYPE',
    defaultMessage: 'Update File Type',
  },
  FILE_TYPES_EXTENSIONS: {
    id: 'FILE_TYPES_EXTENSIONS',
    defaultMessage: 'Extensions',
  },
  FILE_WRONG_TYPE_ERROR_MSG: {
    id: 'FILE_WRONG_TYPE_ERROR_MSG',
    defaultMessage:
      'This file is not a supported file type.\nPlease select a jpeg, gif or png file.',
  },
  FOLDER_PATH_AUTOSYNC_FILES_STRING: {
    id: 'FOLDER_PATH_AUTOSYNC_FILES_STRING',
    defaultMessage: 'Files',
  },
  FOLDER_PATH_ALREADY_EXIST_AS_FILE: {
    id: 'FOLDER_PATH_ALREADY_EXIST_AS_FILE',
    defaultMessage: 'A file exists with this name.',
  },
  FOLDER_PATH_DOES_NOT_EXIST: {
    id: 'FOLDER_PATH_DOES_NOT_EXIST',
    defaultMessage: 'Path does not exist.',
  },
  FOLDER_PATH_ERROR: {
    id: 'FOLDER_PATH_ERROR',
    defaultMessage: 'Error',
  },
  FOLDER_PATH_NOT_VERIFIED: {
    id: 'FOLDER_PATH_NOT_VERIFIED',
    defaultMessage: 'The folder path has not been verified.',
  },
  FOLDER_PATH_PATH: {
    id: 'FOLDER_PATH_PATH',
    defaultMessage: 'Path',
  },
  FOLDER_PATH_OPERATION_INVALID: {
    id: 'FOLDER_PATH_OPERATION_INVALID',
    defaultMessage: 'An invalid operation',
  },
  FOLDER_PATH_SUCCESS: {
    id: 'FOLDER_PATH_SUCCESS',
    defaultMessage: 'Success',
  },
  FOLDER_PATH_TYPE_AUTOSYNC: {
    id: 'FOLDER_PATH_TYPE_AUTOSYNC',
    defaultMessage: 'autosync',
  },
  FOLDER_PATH_TYPE_PREVIEW: {
    id: 'FOLDER_PATH_TYPE_PREVIEW',
    defaultMessage: 'preview',
  },
  FOLDER_PATH_UNKNOWN_FAULT: {
    id: 'FOLDER_PATH_UNKNOWN_FAULT',
    defaultMessage: 'An unknown fault',
  },
  french: {
    id: 'french',
    defaultMessage: 'French',
  },
  FULL_NAME: {
    id: 'FULL_NAME',
    defaultMessage: 'Full Name',
  },
  FULLY_QUALIFIED_DOMAIN_NAME: {
    id: 'FULLY_QUALIFIED_DOMAIN_NAME',
    defaultMessage: 'Fully Qualified Domain Name',
  },
  german: {
    id: 'german',
    defaultMessage: 'German',
  },
  DATA_COLLECTION_HELP_URL: {
    id: 'DATA_COLLECTION_HELP_URL',
    defaultMessage:
      'https://help.portfoliosam.com/hc/en-us/articles/1260804371029',
  },
  DATA_COLLECTION_RTI_OPT_OUT_LABEL: {
    id: 'DATA_COLLECTION_RTI_OPT_OUT_LABEL',
    defaultMessage: 'I agree to share application usage data.',
  },
  DATA_COLLECTION_RTI_OPT_OUT_TEXT: {
    id: 'DATA_COLLECTION_RTI_OPT_OUT_TEXT',
    defaultMessage:
      "Help us deliver the best solutions by sharing application usage with us.\n\nBy accepting, you'll help us gather important information that will guide us toward future quality and feature improvements. The information gathered helps us greatly understand your solution needs.\n\nYou can always change your mind at any time and discontinue sharing information.\n\nFor more information about how we use your information and to opt-out in the future please visit our help article page:",
  },
  DATA_COLLECTION_TITLE: {
    id: 'DATA_COLLECTION_TITLE',
    defaultMessage: 'Analytics',
  },
  GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL: {
    id: 'GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL',
    defaultMessage: 'Create AutoSync folders for new catalogs in this folder',
  },
  GLOBAL_SETTINGS_BACKGROUND_COLOR: {
    id: 'GLOBAL_SETTINGS_BACKGROUND_COLOR',
    defaultMessage: 'Background Color',
  },
  GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP: {
    id: 'GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP',
    defaultMessage: 'Background color of the login screen.',
  },
  GLOBAL_SETTINGS_CATALOG_DEFAULTS: {
    id: 'GLOBAL_SETTINGS_CATALOG_DEFAULTS',
    defaultMessage: 'Catalog Defaults',
  },
  GLOBAL_SETTINGS_CHOOSE_FILE: {
    id: 'GLOBAL_SETTINGS_CHOOSE_FILE',
    defaultMessage: 'Choose File',
  },
  GLOBAL_SETTINGS_CUSTOM_IMAGE: {
    id: 'GLOBAL_SETTINGS_CUSTOM_IMAGE',
    defaultMessage: 'Custom Image',
  },
  GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT: {
    id: 'GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT',
    defaultMessage: 'Approximate size should fit within 2400 x 1350 pixels.',
  },
  GLOBAL_SETTINGS_CUSTOM_TITLE: {
    id: 'GLOBAL_SETTINGS_CUSTOM_TITLE',
    defaultMessage: 'Custom Title',
  },
  GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP: {
    id: 'GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP',
    defaultMessage: 'The title that appears on the browser tab or bookmark.',
  },
  GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN: {
    id: 'GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN',
    defaultMessage: 'Customized Login Screen',
  },
  GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL: {
    id: 'GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL',
    defaultMessage: 'Default Role',
  },
  GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN: {
    id: 'GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN',
    defaultMessage: 'Default Login Screen',
  },
  GLOBAL_SETTINGS_EMAIL_CONFIGURATION: {
    id: 'GLOBAL_SETTINGS_EMAIL_CONFIGURATION',
    defaultMessage: 'Email Notifications',
  },
  GLOBAL_SETTINGS_FADEL: {
    id: 'GLOBAL_SETTINGS_FADEL',
    defaultMessage: 'FADEL Rights Cloud',
  },
  GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG: {
    id: 'GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG',
    defaultMessage:
      'The location of AutoSync and Preview folders must be accessible to the server.',
  },
  GLOBAL_SETTINGS_IMAGE_URL: {
    id: 'GLOBAL_SETTINGS_IMAGE_URL',
    defaultMessage: 'Link',
  },
  GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP: {
    id: 'GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP',
    defaultMessage:
      'Clicking the image will launch this URL in another browser window.',
  },
  GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG: {
    id: 'GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG',
    defaultMessage:
      'To make changes, start the server or check for an expired server license.',
  },
  GLOBAL_SETTINGS_PREVIEW_PATH_LABEL: {
    id: 'GLOBAL_SETTINGS_PREVIEW_PATH_LABEL',
    defaultMessage: 'Save Previews for new catalogs in this folder',
  },
  GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS: {
    id: 'GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS',
    defaultMessage: 'Server Data Locations',
  },
  GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION: {
    id: 'GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION',
    defaultMessage: 'Portfolio Login Customization',
  },
  GLOBAL_SETTINGS_SSO_CREDENTIALS: {
    id: 'GLOBAL_SETTINGS_SSO_CREDENTIALS',
    defaultMessage: 'Single Sign-on Credentials',
  },
  GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP: {
    id: 'GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP',
    defaultMessage:
      'Enter the user account that is associated with the Portfolio Server service for Kerberos authentication.',
  },
  GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL: {
    id: 'GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL',
    defaultMessage: 'Temporary Work folder',
  },
  GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG: {
    id: 'GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG',
    defaultMessage:
      'The work folder will be changed the next time the server is restarted. The new folder will be located at: ',
  },
  GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG: {
    id: 'GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG',
    defaultMessage:
      'You must restart the server for this change to take effect.',
  },
  GLOBAL_SETTINGS_VAULT_CONFIGURATION: {
    id: 'GLOBAL_SETTINGS_VAULT_CONFIGURATION',
    defaultMessage: 'Portfolio Vault Configuration',
  },
  GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL: {
    id: 'GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL',
    defaultMessage: 'Portfolio Vault folder',
  },
  SERVER_DATA_DEFAULT_VAULT_LOCATION_IS: {
    id: 'SERVER_DATA_DEFAULT_VAULT_LOCATION_IS',
    defaultMessage: 'Default:',
  },
  GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE: {
    id: 'GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE',
    defaultMessage: 'To change this folder, first shut down Portfolio server',
  },
  GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE: {
    id: 'GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE',
    defaultMessage:
      'To move Portfolio Vault folder, first shut down Portfolio server.',
  },
  HELP_URL: {
    id: 'HELP_URL',
    defaultMessage:
      'https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm',
  },
  HELP_URL_FADEL: {
    id: 'HELP_URL_FADEL',
    defaultMessage:
      'https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/03_Catalogs/05_FADEL.htm',
  },
  HOSTNAME: {
    id: 'HOSTNAME',
    defaultMessage: 'Hostname',
  },
  IDENTITY_SERVICE_DEFAULT_ROLE_STRING: {
    id: 'IDENTITY_SERVICE_DEFAULT_ROLE_STRING',
    defaultMessage: '(default)',
  },
  IDENTITY_SERVICE_SUCCESSFUL_CREATION: {
    id: 'IDENTITY_SERVICE_SUCCESSFUL_CREATION',
    defaultMessage:
      'Directory Service connection succeeded. Configuration saved.',
  },
  IMAGE_FILE_FILTER: {
    id: 'IMAGE_FILE_FILTER',
    defaultMessage: 'Images (jpg, gif, png)',
  },
  IMPORT_LDAP: {
    id: 'IMPORT_LDAP',
    defaultMessage: 'Import users from LDAP/AD server',
  },
  IMPORT_LDAP_SPECIFY_SERVER: {
    id: 'IMPORT_LDAP_SPECIFY_SERVER',
    defaultMessage: 'Specify LDAP/AD Server',
  },
  IMPORT_MENU_STRING: {
    id: 'IMPORT_MENU_STRING',
    defaultMessage: 'Import Values',
  },
  IMPORT_SOURCE: {
    id: 'IMPORT_SOURCE',
    defaultMessage: 'Import Source',
  },
  INVALID_DN_SYNTAX_ERROR: {
    id: 'INVALID_DN_SYNTAX_ERROR',
    defaultMessage:
      'Unable to connect to the directory service due to invalid DN syntax error. Please check the username.',
  },
  japanese: {
    id: 'japanese',
    defaultMessage: 'Japanese',
  },
  LAST_CERTIFICATE_REQUEST_LABEL: {
    id: 'LAST_CERTIFICATE_REQUEST_LABEL',
    defaultMessage: 'Last Certificate Request',
  },
  LAST_MODIFIED_BY: {
    id: 'LAST_MODIFIED_BY',
    defaultMessage: 'Last Modified By',
  },
  LAST_MODIFIED_DATE: {
    id: 'LAST_MODIFIED_DATE',
    defaultMessage: 'Date Last Modified',
  },
  LDAP_ADDRESS: {
    id: 'LDAP_ADDRESS',
    defaultMessage: 'LDAP/AD Server address',
  },
  LDAP_BIND_USERNAME: {
    id: 'LDAP_BIND_USERNAME',
    defaultMessage: 'LDAP Bind Username',
  },
  LDAP_SYNC_NOTIFICATION: {
    id: 'LDAP_SYNC_NOTIFICATION',
    defaultMessage: 'The server has received the sync request.',
  },
  LIC_ACTIVATE: {
    id: 'LIC_ACTIVATE',
    defaultMessage: 'Activate Portfolio',
  },
  LIC_ADD_MESSAGE: {
    id: 'LIC_ADD_MESSAGE',
    defaultMessage:
      'Copy and Paste Licenses or enter individually one per row.',
  },
  LIC_ADD_SN: {
    id: 'LIC_ADD_SN',
    defaultMessage: 'Add New License',
  },
  LIC_ADD_SN_SHORT: {
    id: 'LIC_ADD_SN_SHORT',
    defaultMessage: 'Add Licenses',
  },
  LIC_ASSET_CAP_DISPLAY: {
    id: 'LIC_ASSET_CAP_DISPLAY',
    defaultMessage: 'Assets',
  },
  LIC_CLICK_TO_ACTIVATE: {
    id: 'LIC_CLICK_TO_ACTIVATE',
    defaultMessage: 'Activate Portfolio with your Extensis credentials',
  },
  LIC_CLICK_TO_UPGRADE: {
    id: 'LIC_CLICK_TO_UPGRADE',
    defaultMessage: 'Click to upgrade Portfolio Server',
  },
  LIC_CLICK_TO_USE: {
    id: 'LIC_CLICK_TO_USE',
    defaultMessage:
      'Try Portfolio for a limited time with a Demo Serial Number',
  },
  LIC_DAYS_REMAINING: {
    id: 'LIC_DAYS_REMAINING',
    defaultMessage: '({days} Days Remaining)',
  },
  LIC_DEMO_PERIOD: {
    id: 'LIC_DEMO_PERIOD',
    defaultMessage: 'Demo Period',
  },
  LIC_ERROR_MSG: {
    id: 'LIC_ERROR_MSG',
    defaultMessage:
      'Invalid serial number, please re-try. If the problem persists check your server log or contact your administrator.',
  },
  LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG: {
    id: 'LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG',
    defaultMessage: 'The serial number cannot be added to Portfolio Studio.',
  },
  LIC_MAINTENANCE_END_DATE: {
    id: 'LIC_MAINTENANCE_END_DATE',
    defaultMessage: 'Maintenance/Subscription End Date',
  },
  LIC_SEAT_DISPLAY: {
    id: 'LIC_SEAT_DISPLAY',
    defaultMessage: 'User Seats',
  },
  LIC_TRIAL: {
    id: 'LIC_TRIAL',
    defaultMessage: 'Try Portfolio',
  },
  LITE_CANNOT_CREATE_FDB_CATALOG: {
    id: 'LITE_CANNOT_CREATE_FDB_CATALOG',
    defaultMessage:
      'Your Portfolio license does not allow more than one catalog. Please consider upgrading your Portfolio license to perform this action.',
  },
  LITE_CANNOT_SERVE_FDB_CATALOG: {
    id: 'LITE_CANNOT_SERVE_FDB_CATALOG',
    defaultMessage:
      'Your Portfolio Server license does not allow further catalogs to be taken online.',
  },
  LITE_THIS_FEATURE_NOT_SUPPORTED: {
    id: 'LITE_THIS_FEATURE_NOT_SUPPORTED',
    defaultMessage:
      'Your Portfolio Server license does not support this action.',
  },
  LOGGING_CONFIGURATION: {
    id: 'LOGGING_CONFIGURATION',
    defaultMessage: 'Logging Configuration',
  },
  LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE: {
    id: 'LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE',
    defaultMessage: 'To move Logs folder, first shut down Portfolio server.',
  },
  LOGGING_DEFAULT_LOCATION_MSG: {
    id: 'LOGGING_DEFAULT_LOCATION_MSG',
    defaultMessage: 'The default log location is',
  },
  LOGGING_DIR_MUST_EXIST: {
    id: 'LOGGING_DIR_MUST_EXIST',
    defaultMessage:
      'NOTE: In order to successfully change the log directory, the newly specified directory must already exist and be writeable by the user under which the Portfolio Server is running.',
  },
  LOGGING_LOG_DIR: {
    id: 'LOGGING_LOG_DIR',
    defaultMessage: 'Logs folder',
  },
  LOGGING_LOG_LEVEL: {
    id: 'LOGGING_LOG_LEVEL',
    defaultMessage: 'Log level',
  },
  LOGGING_NUM_LOGS_TO_RETAIN: {
    id: 'LOGGING_NUM_LOGS_TO_RETAIN',
    defaultMessage: 'Number of logs to retain',
  },
  LOGIN: {
    id: 'LOGIN',
    defaultMessage: 'Login',
  },
  MAPPING_HEADER: {
    id: 'MAPPING_HEADER',
    defaultMessage: 'User/Group Mapping to Portfolio',
  },
  MAPPINGS_HAVE_BEEN_MODIFIED_ALERT: {
    id: 'MAPPINGS_HAVE_BEEN_MODIFIED_ALERT',
    defaultMessage:
      'The mappings have been modified, would you like to save them?',
  },
  MEDIA_ENGINE_NOT_OPERATIONAL: {
    id: 'MEDIA_ENGINE_NOT_OPERATIONAL',
    defaultMessage: 'The media engine could not be accessed.',
  },
  MEDIA_ENGINE_OPERATIONAL: {
    id: 'MEDIA_ENGINE_OPERATIONAL',
    defaultMessage: 'The media engine is operational.',
  },
  MEDIA_ENGINES_ACTION_ADD: {
    id: 'MEDIA_ENGINES_ACTION_ADD',
    defaultMessage: 'Add New Media Engine',
  },
  MEDIA_ENGINES_ACTION_DELETE: {
    id: 'MEDIA_ENGINES_ACTION_DELETE',
    defaultMessage: 'Delete Media Engine',
  },
  MEDIA_ENGINES_ACTION_EDIT: {
    id: 'MEDIA_ENGINES_ACTION_EDIT',
    defaultMessage: 'View/Edit Media Engine Details',
  },
  MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE: {
    id: 'MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE',
    defaultMessage:
      'You can not add another active Media Engine because the server is already using the maximum number of active media engines allowed by your Portfolio Media Engine license.',
  },
  MEDIA_ENGINES_CANT_ADD_NO_LICENSES: {
    id: 'MEDIA_ENGINES_CANT_ADD_NO_LICENSES',
    defaultMessage:
      "You can not add a Media Engine because the server doesn't have any available Portfolio Media Engine licenses.",
  },
  MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER: {
    id: 'MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER',
    defaultMessage: 'You can not remove the built in Media Engine.',
  },
  MEDIA_ENGINES_COLUMN_ACTIVE: {
    id: 'MEDIA_ENGINES_COLUMN_ACTIVE',
    defaultMessage: 'Active',
  },
  MEDIA_ENGINES_COLUMN_ADDRESS: {
    id: 'MEDIA_ENGINES_COLUMN_ADDRESS',
    defaultMessage: 'Address',
  },
  MEDIA_ENGINES_COLUMN_PORT: {
    id: 'MEDIA_ENGINES_COLUMN_PORT',
    defaultMessage: 'Port',
  },
  MEDIA_ENGINES_COLUMN_TEST: {
    id: 'MEDIA_ENGINES_COLUMN_TEST',
    defaultMessage: 'Test',
  },
  MEDIA_ENGINES_CONFIRM_DELETE: {
    id: 'MEDIA_ENGINES_CONFIRM_DELETE',
    defaultMessage: 'Do you want to delete the selected Media Engine?',
  },
  MEDIA_ENGINES_EDIT_DETAILS_HEADER: {
    id: 'MEDIA_ENGINES_EDIT_DETAILS_HEADER',
    defaultMessage: 'Media Engine Details',
  },
  MEDIA_ENGINES_LICENSES_LABEL: {
    id: 'MEDIA_ENGINES_LICENSES_LABEL',
    defaultMessage: 'Media Engine seats available for activation',
  },
  MEDIA_ENGINES_NEW_DETAILS_HEADER: {
    id: 'MEDIA_ENGINES_NEW_DETAILS_HEADER',
    defaultMessage: 'New Media Engine Details',
  },
  MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE: {
    id: 'MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE',
    defaultMessage:
      'No Media Engines are active. You should activate a Media Engine before clients need to use Portfolio Media services.',
  },
  MOBILE_TITLE: {
    id: 'MOBILE',
    defaultMessage: 'Mobile',
  },
  MOBILE_ENABLED: {
    id: 'MOBILE_ENABLED',
    defaultMessage: 'Enable Mobile Uploading',
  },
  MOBILE_FOLDER_VERBIAGE: {
    id: 'MOBILE_FOLDER_VERBIAGE',
    defaultMessage: 'Save mobile uploads to this folder:',
  },
  MOBILE_CREATE_CATALOG_VERBIAGE: {
    id: 'MOBILE_CREATE_CATALOG_VERBIAGE',
    defaultMessage:
      "Create new catalog 'Mobile Uploads' to automatically watch this folder (recommended)",
  },
  MOBILE_CATALOG_NAME: {
    id: 'MOBILE_CATALOG_NAME',
    defaultMessage: 'Mobile Uploads',
  },
  modifyAssetContents: {
    id: 'modifyAssetContents',
    defaultMessage: 'Check Out Assets',
  },
  modifyAssetProperties: {
    id: 'modifyAssetProperties',
    defaultMessage: 'Update Asset Fields',
  },
  MODIFY_LDAP: {
    id: 'MODIFY_LDAP',
    defaultMessage: 'Modify LDAP query',
  },
  NAME: {
    id: 'NAME',
    defaultMessage: 'Name',
  },
  NAME_TOO_LONG_ERROR: {
    id: 'NAME_TOO_LONG_ERROR',
    defaultMessage: 'Name must be less than 256 characters.',
  },
  NAV_ABOUT: {
    id: 'NAV_ABOUT',
    defaultMessage: 'About',
  },
  NAV_ACCESS_LEVELS: {
    id: 'NAV_ACCESS_LEVELS',
    defaultMessage: 'Roles',
  },
  NAV_AUTOSYNC: {
    id: 'NAV_AUTOSYNC',
    defaultMessage: 'Autosync',
  },
  NAV_BACKUPS: {
    id: 'NAV_BACKUPS',
    defaultMessage: 'Backup/Restore',
  },
  NAV_CATALOGS: {
    id: 'NAV_CATALOGS',
    defaultMessage: 'Catalogs',
  },
  NAV_GLOBAL_SETTINGS: {
    id: 'NAV_GLOBAL_SETTINGS',
    defaultMessage: 'Global Settings',
  },
  NAV_HELP: {
    id: 'NAV_HELP',
    defaultMessage: 'Help',
  },
  NAV_LICENSES: {
    id: 'NAV_LICENSES',
    defaultMessage: 'Licenses',
  },
  NAV_LOGOUT: {
    id: 'NAV_LOGOUT',
    defaultMessage: 'Logout',
  },
  NAV_MEDIA_ENGINES: {
    id: 'NAV_MEDIA_ENGINES',
    defaultMessage: 'Media Engines',
  },
  NAV_NETPUBLISH_SETTINGS: {
    id: 'NAV_NETPUBLISH_SETTINGS',
    defaultMessage: 'NetPublish',
  },
  NAV_PORTS: {
    id: 'NAV_PORTS',
    defaultMessage: 'Ports',
  },
  NAV_REPORTING: {
    id: 'NAV_REPORTING',
    defaultMessage: 'Reports',
  },
  NAV_SETTINGS: {
    id: 'NAV_SETTINGS',
    defaultMessage: 'Settings',
  },
  NAV_STATUS: {
    id: 'NAV_STATUS',
    defaultMessage: 'Status',
  },
  NAV_USERS: {
    id: 'NAV_USERS',
    defaultMessage: 'Users',
  },
  NP_SITES: {
    id: 'NP_SITES',
    defaultMessage: 'NetPublish Sites',
  },
  NP_SITE_DELETE_LABEL: {
    id: 'NP_SITE_DELETE_LABEL',
    defaultMessage: 'Delete Site',
  },
  NP_SITE_ENABLED_LABEL: {
    id: 'NP_SITE_ENABLED_LABEL',
    defaultMessage: 'Site Enabled',
  },
  NO_CATALOGS: {
    id: 'NO_CATALOGS',
    defaultMessage: 'None',
  },
  NO_CATALOGS_EXIST: {
    id: 'NO_CATALOGS_EXIST',
    defaultMessage:
      'No Catalogs exist.\n\nClick the + button to create a Catalog.',
  },
  NO_FILE_SELECTED: {
    id: 'NO_FILE_SELECTED',
    defaultMessage: 'No File Selected',
  },
  NO_SITES_EXIST_1: {
    id: 'NO_SITES_EXIST_1',
    defaultMessage: 'No NetPublish Sites exist.',
  },
  NO_SITES_EXIST_2: {
    id: 'NO_SITES_EXIST_2',
    defaultMessage:
      'Use the Publish option found within Portfolio to create and publish Sites.',
  },
  VaultFolderNotFound: {
    id: 'VaultFolderNotFound',
    defaultMessage: 'The Portfolio Vault folder was not found at {path}.',
  },
  NO_VAULT_FOLDER: {
    id: 'NO_VAULT_FOLDER',
    defaultMessage:
      'The Portfolio Vault folder was not found at {path}.\n\nPlease check the location of the folder on your file system, and in the Global Settings -> Server Data page of this application.',
  },
  NOTES: {
    id: 'NOTES',
    defaultMessage: 'Notes',
  },
  NOTIFICATION_FAILURE_ADD: {
    id: 'NOTIFICATION_FAILURE_ADD',
    defaultMessage: 'Add Unsuccessful',
  },
  NOTIFICATION_SUCCESS_UPDATE: {
    id: 'NOTIFICATION_SUCCESS_UPDATE',
    defaultMessage: 'Update Successful',
  },
  NOTIFICATION_FAILURE_UPDATE: {
    id: 'NOTIFICATION_FAILURE_UPDATE',
    defaultMessage: 'Update Unsuccessful',
  },
  NP_DELETE_SITE_CONFIRMATION: {
    id: 'NP_DELETE_SITE_CONFIRMATION',
    defaultMessage: 'Do you want to permanently delete the Site?',
  },
  NP_SOURCE: {
    id: 'NP_SOURCE',
    defaultMessage: 'Source',
  },
  NUMBER_DECIMAL_POINT_COUNT_ERROR: {
    id: 'NUMBER_DECIMAL_POINT_COUNT_ERROR',
    defaultMessage: 'The decimal separator can only occur once.',
  },
  NUMBER_EXCEEDS_MAX_ERROR: {
    id: 'NUMBER_EXCEEDS_MAX_ERROR',
    defaultMessage: 'The number entered is too large.',
  },
  NUMBER_INTEGER_ERROR: {
    id: 'NUMBER_INTEGER_ERROR',
    defaultMessage: 'The number must be an integer.',
  },
  NUMBER_INVALID_CHAR_ERROR: {
    id: 'NUMBER_INVALID_CHAR_ERROR',
    defaultMessage: 'The input contains invalid characters.',
  },
  NUMBER_INVALID_FORMAT_CHARS_ERROR: {
    id: 'NUMBER_INVALID_FORMAT_CHARS_ERROR',
    defaultMessage: 'One of the formatting parameters is invalid.',
  },
  NUMBER_LOWER_THAN_MIN_ERROR: {
    id: 'NUMBER_LOWER_THAN_MIN_ERROR',
    defaultMessage: 'The amount entered is too small.',
  },
  NUMBER_NEGATIVE_ERROR: {
    id: 'NUMBER_NEGATIVE_ERROR',
    defaultMessage: 'The amount may not be negative.',
  },
  NUMBER_PRECISION_ERROR: {
    id: 'NUMBER_PRECISION_ERROR',
    defaultMessage:
      'The amount entered has too many digits beyond the decimal point.',
  },
  NUMBER_SEPARATION_ERROR: {
    id: 'NUMBER_SEPARATION_ERROR',
    defaultMessage: 'The thousands separator must be followed by three digits.',
  },
  OK: {
    id: 'OK',
    defaultMessage: 'OK',
  },
  ON_DATE: {
    id: 'ON_DATE',
    defaultMessage: 'on',
  },
  OPEN_DIRECTORY: {
    id: 'OPEN_DIRECTORY',
    defaultMessage: 'Open Directory',
  },
  OPEN_DIRECTORY_GROUPS: {
    id: 'OPEN_DIRECTORY_GROUPS',
    defaultMessage: 'Groups',
  },
  ORGANIZATION_NAME: {
    id: 'ORGANIZATION_NAME',
    defaultMessage: 'Organization Name',
  },
  ORGANIZATIONAL_UNIT: {
    id: 'ORGANIZATIONAL_UNIT',
    defaultMessage: 'Organizational Unit',
  },
  PASSWORD: {
    id: 'PASSWORD',
    defaultMessage: 'Password',
  },
  PASSWORD_CONFIRM: {
    id: 'PASSWORD_CONFIRM',
    defaultMessage: 'Confirm Password',
  },
  PASSWORD_TOO_LONG_ERROR: {
    id: 'PASSWORD_TOO_LONG_ERROR',
    defaultMessage: 'Password must be less than 256 characters.',
  },
  PORT: {
    id: 'PORT',
    defaultMessage: 'Port',
  },
  PORT_VALUE_TOO_HIGH_ERROR: {
    id: 'PORT_VALUE_TOO_HIGH_ERROR',
    defaultMessage: 'Port value must be less than 65536.',
  },
  PortfolioAssetCap: {
    id: 'PortfolioAssetCap',
    defaultMessage: 'Portfolio Asset Cap',
  },
  PortfolioAPI: {
    id: 'PortfolioAPI',
    defaultMessage: 'Portfolio API',
  },
  PortfolioDemo: {
    id: 'PortfolioDemo',
    defaultMessage: 'Demo',
  },
  PortfolioDirServices: {
    id: 'PortfolioDirServices',
    defaultMessage: 'Portfolio Directory Services',
  },
  PortfolioServer: {
    id: 'PortfolioServer',
    defaultMessage: 'Portfolio Server',
  },
  PortfolioStudio: {
    id: 'PortfolioStudio',
    defaultMessage: 'Portfolio Studio Edition',
  },
  PortfolioProfessional: {
    id: 'PortfolioProfessional',
    defaultMessage: 'Portfolio Professional Edition',
  },
  PortfolioEnterprise: {
    id: 'PortfolioEnterprise',
    defaultMessage: 'Portfolio Enterprise Edition',
  },
  PortfolioMediaEngine: {
    id: 'PortfolioMediaEngine',
    defaultMessage: 'Portfolio Media Engine',
  },
  NetPublish: {
    id: 'NetPublish',
    defaultMessage: 'Portfolio NetPublish',
  },
  PortfolioMobile: {
    id: 'PortfolioMobile',
    defaultMessage: 'Portfolio Flow',
  },
  PortfolioSmartKeywords: {
    id: 'PortfolioSmartKeywords',
    defaultMessage: 'Portfolio Smart Keywords',
  },
  PortfolioUserConnection: {
    id: 'PortfolioUserConnection',
    defaultMessage: 'Portfolio User Connection',
  },
  PortfolioSingleSignOn: {
    id: 'PortfolioSingleSignOn',
    defaultMessage: 'Single Sign On (SSO)',
  },
  PORT_TITLE: {
    id: 'PORT_TITLE',
    defaultMessage: 'Ports',
  },
  PORT_DEFAULT: {
    id: 'PORT_DEFAULT',
    defaultMessage: 'Default:',
  },
  PORT_CURRENT_VALUE: {
    id: 'PORT_CURRENT_VALUE',
    defaultMessage: 'Current Value',
  },
  PORT_ERROR_MSG_BAD_PORT_VALUE: {
    id: 'PORT_ERROR_MSG_BAD_PORT_VALUE',
    defaultMessage: 'The new port value must be a number between 1 and 65535.',
  },
  PORT_ERROR_MSG_CONFLICT: {
    id: 'PORT_ERROR_MSG_CONFLICT',
    defaultMessage:
      'Can not update port values because one or more of the new port values is already in use on the server.',
  },
  PORT_FIND_PORT: {
    id: 'PORT_FIND_PORT',
    defaultMessage: 'Find Port',
  },
  PORT_NAME: {
    id: 'PORT_NAME',
    defaultMessage: 'Name',
  },
  PORT_NEW_VALUE: {
    id: 'PORT_NEW_VALUE',
    defaultMessage: 'New Value',
  },
  PORT_RESTART_NOTICE: {
    id: 'PORT_RESTART_NOTICE',
    defaultMessage:
      'Note: port updates do not take effect until the server is restarted.',
  },
  PORT_RESTART_SERVER: {
    id: 'PORT_RESTART_SERVER',
    defaultMessage: 'Restart Server',
  },
  PORT_UPDATE_PORTS: {
    id: 'PORT_UPDATE_PORTS',
    defaultMessage: 'Update Ports',
  },
  PORT_WARNING_ADMIN_RESTART: {
    id: 'PORT_WARNING_ADMIN_RESTART',
    defaultMessage:
      'The admin port was changed. The browser will be redirected to the new location in {numSecs} seconds.',
  },
  PREVIEW_MAX_VIDEO_RESOLUTION_360: {
    id: 'PREVIEW_MAX_VIDEO_RESOLUTION_360',
    defaultMessage: '360p',
  },
  PREVIEW_MAX_VIDEO_RESOLUTION_480: {
    id: 'PREVIEW_MAX_VIDEO_RESOLUTION_480',
    defaultMessage: '480p',
  },
  PREVIEW_MAX_VIDEO_RESOLUTION_540: {
    id: 'PREVIEW_MAX_VIDEO_RESOLUTION_540',
    defaultMessage: '540p HD',
  },
  PREVIEW_MAX_VIDEO_RESOLUTION_720: {
    id: 'PREVIEW_MAX_VIDEO_RESOLUTION_720',
    defaultMessage: '720p HD',
  },
  PREVIEW_MAX_VIDEO_RESOLUTION_1080: {
    id: 'PREVIEW_MAX_VIDEO_RESOLUTION_1080',
    defaultMessage: '1080p HD',
  },
  PROMPT_ARE_YOU_SURE: {
    id: 'PROMPT_ARE_YOU_SURE',
    defaultMessage: 'Are you sure?',
  },
  PROMPT_COULD_NOT_CREATE_FOLDER: {
    id: 'PROMPT_COULD_NOT_CREATE_FOLDER',
    defaultMessage:
      'That folder could not be created. Please enter another path.',
  },
  PROMPT_COULD_NOT_CREATE_FOLDERS: {
    id: 'PROMPT_COULD_NOT_CREATE_FOLDERS',
    defaultMessage:
      'Please enter another folder path because the following paths could not be created:',
  },
  PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT: {
    id: 'PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT',
    defaultMessage:
      "That folder could not be created because there's already a file with that name. Please enter another path.",
  },
  PROMPT_CREATE_THAT_FOLDER: {
    id: 'PROMPT_CREATE_THAT_FOLDER',
    defaultMessage: 'That folder does not exist. Create it?',
  },
  PROMPT_CREATE_THESE_FOLDERS: {
    id: 'PROMPT_CREATE_THESE_FOLDERS',
    defaultMessage: 'These folders do not exist. Do you want to create them?',
  },
  PROMPT_DELETE_LICENSE_CONFIRM: {
    id: 'PROMPT_DELETE_LICENSE_CONFIRM',
    defaultMessage: 'Do you want to delete the selected license?',
  },
  QUERY: {
    id: 'QUERY',
    defaultMessage: 'Query',
  },
  REMOVE: {
    id: 'REMOVE',
    defaultMessage: 'Remove',
  },
  REMOVE_DIRECTORY_SERVICE: {
    id: 'REMOVE_DIRECTORY_SERVICE',
    defaultMessage: 'Remove Service',
  },
  REPLACE_USER_MAPPING_CONFIRMATION: {
    id: 'REPLACE_USER_MAPPING_CONFIRMATION',
    defaultMessage:
      'A regular user mapping already exists for this user. Replace it with an exclude user mapping?',
  },
  REPLACE_USER_EXCLUSION_CONFIRMATION: {
    id: 'REPLACE_USER_EXCLUSION_CONFIRMATION',
    defaultMessage:
      'An exclude user mapping already exists for this user. Replace it with a regular user mapping?',
  },
  REQUIRED_FIELD_ERROR: {
    id: 'REQUIRED_FIELD_ERROR',
    defaultMessage: 'This field is required.',
  },
  REVERT: {
    id: 'REVERT',
    defaultMessage: 'Revert',
  },
  REVERT_CHANGES: {
    id: 'REVERT_CHANGES',
    defaultMessage: 'Revert Changes',
  },
  ROLES_CREATE_ROLE_TITLE: {
    id: 'ROLES_CREATE_ROLE_TITLE',
    defaultMessage: 'Create Role',
  },
  ROLES_DELETE_CONFIRM: {
    id: 'ROLES_DELETE_CONFIRM',
    defaultMessage:
      'Do you want to delete the selected Role?\nUsers with this Role will be demoted to Readers.',
  },
  ROLE_FOR_IMPORT: {
    id: 'ROLE_FOR_IMPORT',
    defaultMessage: 'Role for Import',
  },
  ROLES_PERMISSIONS: {
    id: 'ROLES_PERMISSIONS',
    defaultMessage: 'Permissions',
  },
  ROLES_PERMISSION_ENABLED_HEADER: {
    id: 'ROLES_PERMISSION_ENABLED_HEADER',
    defaultMessage: 'Enabled',
  },
  ROLES_PERMISSION_NAME_HEADER: {
    id: 'ROLES_PERMISSION_NAME_HEADER',
    defaultMessage: 'Operation',
  },
  SAVE: {
    id: 'SAVE',
    defaultMessage: 'Save',
  },
  SAVE_MAPPING: {
    id: 'SAVE_MAPPING',
    defaultMessage: 'Save Mapping',
  },
  saveOutputSetting: {
    id: 'saveOutputSetting',
    defaultMessage: 'Manage Presets (Convert and Make PDF)',
  },
  SEARCH: {
    id: 'SEARCH',
    defaultMessage: 'Search',
  },
  SEARCH_BASE: {
    id: 'SEARCH_BASE',
    defaultMessage: 'Search Base',
  },
  SEARCH_RESULTS: {
    id: 'SEARCH_RESULTS',
    defaultMessage: 'Search Results',
  },
  SECURITY_GROUPS: {
    id: 'SECURITY_GROUPS',
    defaultMessage: 'Security Groups',
  },
  SELECT: {
    id: 'SELECT',
    defaultMessage: 'Select',
  },
  SEND_DIAGNOSTIC_DATA: {
    id: 'SEND_DIAGNOSTIC_DATA',
    defaultMessage: 'Send diagnostic report to Extensis',
  },
  SERVER_DATA_DEFAULT_WORK_LOCATION_IS: {
    id: 'SERVER_DATA_DEFAULT_WORK_LOCATION_IS',
    defaultMessage: 'Default work location: ',
  },
  SERVER_RESTART_REQUIRED: {
    id: 'SERVER_RESTART_REQUIRED',
    defaultMessage: 'The server must be restarted for changes to take effect.',
  },
  SERVER_STATE_ERROR: {
    id: 'SERVER_STATE_ERROR',
    defaultMessage: 'Error: See Admin Log for Details',
  },
  SERVER_STATE_STARTED: {
    id: 'SERVER_STATE_STARTED',
    defaultMessage: 'Running',
  },
  SERVER_STATE_STARTING: {
    id: 'SERVER_STATE_STARTING',
    defaultMessage: 'Starting',
  },
  SERVER_STATE_STOPPED: {
    id: 'SERVER_STATE_STOPPED',
    defaultMessage: 'Stopped',
  },
  SERVER_STATE_STOPPING: {
    id: 'SERVER_STATE_STOPPING',
    defaultMessage: 'Stopping',
  },
  SERVER_STATE_UNKNOWN: {
    id: 'SERVER_STATE_UNKNOWN',
    defaultMessage: 'Unknown',
  },
  SERVICE_BROWSER: {
    id: 'SERVICE_BROWSER',
    defaultMessage: 'Service Browser',
  },
  SK_ENGINE_APPAREL: {
    id: 'SK_ENGINE_APPAREL',
    defaultMessage: 'Apparel',
  },
  SK_ENGINE_ART_STYLE: {
    id: 'SK_ENGINE_ART_STYLE',
    defaultMessage: 'Art Style',
  },
  SK_ENGINE_ART_SUBJECT: {
    id: 'SK_ENGINE_ART_SUBJECT',
    defaultMessage: 'Art Subject',
  },
  SK_ENGINE_ART_MOVEMENT: {
    id: 'SK_ENGINE_ART_MOVEMENT',
    defaultMessage: 'Art Movement',
  },
  SK_ENGINE_CELEBRITIES: {
    id: 'SK_ENGINE_CELEBRITIES',
    defaultMessage: 'Celebrities',
  },
  SK_ENGINE_FOOD: {
    id: 'SK_ENGINE_FOOD',
    defaultMessage: 'Food',
  },
  SK_ENGINE_GENERAL: {
    id: 'SK_ENGINE_GENERAL',
    defaultMessage: 'General',
  },
  SK_ENGINE_LOGO: {
    id: 'SK_ENGINE_LOGO',
    defaultMessage: 'Logo',
  },
  SK_ENGINE_MODERATION: {
    id: 'SK_ENGINE_MODERATION',
    defaultMessage: 'Moderation',
  },
  SK_ENGINE_NSFW: {
    id: 'SK_ENGINE_NSFW',
    defaultMessage: 'NSFW',
  },
  SK_ENGINE_TRAVEL: {
    id: 'SK_ENGINE_TRAVEL',
    defaultMessage: 'Travel',
  },
  SK_ENGINE_WEDDINGS: {
    id: 'SK_ENGINE_WEDDINGS',
    defaultMessage: 'Weddings',
  },
  SSL_HANDSHAKE_ERROR: {
    id: 'SSL_HANDSHAKE_ERROR',
    defaultMessage:
      'SSL handshake failed; please verify that the port and SSL settings are correct.',
  },
  STARTS_WITH: {
    id: 'STARTS_WITH',
    defaultMessage: 'starts with',
  },
  STATE_OR_PROVINCE: {
    id: 'STATE_OR_PROVINCE',
    defaultMessage: 'State or Province',
  },
  STATUS: {
    id: 'STATUS',
    defaultMessage: 'Status',
  },
  STATUS_ADMIN_LOG: {
    id: 'STATUS_ADMIN_LOG',
    defaultMessage: 'Admin Log',
  },
  STATUS_API_VERSION_LABEL: {
    id: 'STATUS_API_VERSION_LABEL',
    defaultMessage: 'API',
  },
  STATUS_API_STATE_LICENSED: {
    id: 'STATUS_API_STATE_LICENSED',
    defaultMessage: 'Licensed',
  },
  STATUS_API_STATE_UNLICENSED: {
    id: 'STATUS_API_STATE_UNLICENSED',
    defaultMessage: 'Not licensed',
  },
  STATUS_CLEAR_ADMIN_LOG: {
    id: 'STATUS_CLEAR_ADMIN_LOG',
    defaultMessage: 'Clear Admin Log',
  },
  STATUS_CONNECTED_USERS: {
    id: 'STATUS_CONNECTED_USERS',
    defaultMessage: 'Connected Users',
  },
  STATUS_MAX_ALLOWED_CONNECTIONS: {
    id: 'STATUS_MAX_ALLOWED_CONNECTIONS',
    defaultMessage: 'Maximum Connections',
  },
  STATUS_MEDIA_ENGINE_VERSION_LABEL: {
    id: 'STATUS_MEDIA_ENGINE_VERSION_LABEL',
    defaultMessage: 'Media Engine',
  },
  STATUS_MEDIA_ENGINES_ACTIVE: {
    id: 'STATUS_MEDIA_ENGINES_ACTIVE',
    defaultMessage: 'Active',
  },
  STATUS_MEDIA_ENGINES_LABEL: {
    id: 'STATUS_MEDIA_ENGINES_LABEL',
    defaultMessage: 'Media Engines',
  },
  STATUS_RESTART_SERVER: {
    id: 'STATUS_RESTART_SERVER',
    defaultMessage: 'Restart Portfolio',
  },
  STATUS_SEAT_USAGE: {
    id: 'STATUS_SEAT_USAGE',
    defaultMessage: 'Seat Usage',
  },
  STATUS_SERVER_STATE: {
    id: 'STATUS_SERVER_STATE',
    defaultMessage: 'Portfolio State',
  },
  STATUS_SERVER_VERSION_LABEL: {
    id: 'STATUS_SERVER_VERSION_LABEL',
    defaultMessage: 'Portfolio',
  },
  STATUS_START_SERVER: {
    id: 'STATUS_START_SERVER',
    defaultMessage: 'Start Portfolio',
  },
  STATUS_STOP_SERVER: {
    id: 'STATUS_STOP_SERVER',
    defaultMessage: 'Stop Portfolio',
  },
  STATUS_PROBLEMS_DETECTED: {
    id: 'STATUS_PROBLEMS_DETECTED',
    defaultMessage: 'Problems detected:',
  },
  STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM: {
    id: 'STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM',
    defaultMessage: 'Remaining startup disk space is under {minSpace}GB.',
  },
  STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS: {
    id: 'STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS',
    defaultMessage:
      'The system memory is {value}GB which is below the {minGB}GB minimum requirements.',
  },
  STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE: {
    id: 'STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE',
    defaultMessage:
      'The system memory computed by Portfolio is {value}GB which may be inaccurate.',
  },
  STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST: {
    id: 'STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST',
    defaultMessage: 'The work folder does not exist or is inaccessible.',
  },
  STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE: {
    id: 'STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE',
    defaultMessage: 'The Portfolio server cannot write to the work folder.',
  },
  STATUS_MSG_WORK_FOLDER_NOT_READABLE: {
    id: 'STATUS_MSG_WORK_FOLDER_NOT_READABLE',
    defaultMessage: 'The Portfolio server cannot read from the work folder.',
  },
  STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE: {
    id: 'STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE',
    defaultMessage:
      'The Portfolio server cannot create symlinks in the work folder.',
  },
  STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW: {
    id: 'STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW',
    defaultMessage: 'Remaining work folder disk space is under {minSpace}GB.',
  },
  STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS: {
    id: 'STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS',
    defaultMessage: 'Unable to get work folder status.',
  },
  STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED: {
    id: 'STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED',
    defaultMessage: 'The status for elasticsearch index {index} is red.',
  },
  STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS: {
    id: 'STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS',
    defaultMessage: 'The elasticsearch index {index} has uninitialized shards.',
  },
  STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE: {
    id: 'STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE',
    defaultMessage:
      'Not all shards are active for the elasticsearch index {index}.',
  },
  STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS: {
    id: 'STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS',
    defaultMessage: 'Unable to retrieve elasticsearch status.',
  },
  STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER: {
    id: 'STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER',
    defaultMessage: 'Unable to retrieve errors from the Portfolio server.',
  },
  STATUS_MSG_STARTUP_FAILED: {
    id: 'STATUS_MSG_STARTUP_FAILED',
    defaultMessage: 'Startup failed',
  },
  STATUS_MSG_CANT_GET_SERVER_HEALTH: {
    id: 'STATUS_MSG_CANT_GET_SERVER_HEALTH',
    defaultMessage: 'Unable to update server health.',
  },
  STATUS_MSG_NATIVE_AGENT_NOT_RUNNING: {
    id: 'STATUS_MSG_NATIVE_AGENT_NOT_RUNNING',
    defaultMessage: 'The native-agent server component is not running.',
  },
  SUBJECT_ALTERNATIVE_NAMES: {
    id: 'SUBJECT_ALTERNATIVE_NAMES',
    defaultMessage: 'Subject Alternative Names',
  },
  SUBMIT: {
    id: 'SUBMIT',
    defaultMessage: 'Submit',
  },
  swedish: {
    id: 'swedish',
    defaultMessage: 'Swedish',
  },
  SYNC_DAILY: {
    id: 'SYNC_DAILY',
    defaultMessage: 'Synchronize Daily',
  },
  synchronizeAutoSyncFolder: {
    id: 'synchronizeAutoSyncFolder',
    defaultMessage: 'Sync Autosync Folders',
  },
  SYNCHRONIZE_NOW: {
    id: 'SYNCHRONIZE_NOW',
    defaultMessage: 'Synchronize Now',
  },
  TARGET_CATALOG: {
    id: 'TARGET_CATALOG',
    defaultMessage: 'Target Catalog',
  },
  THIS_LOCALE: {
    id: 'THIS_LOCALE',
    defaultMessage: 'en',
  },
  TRUE_LABEL: {
    id: 'TRUE_LABEL',
    defaultMessage: 'True',
  },
  TOKEN: {
    id: 'TOKEN',
    defaultMessage: 'Token',
  },
  TOTAL_ASSETS: {
    id: 'TOTAL_ASSETS',
    defaultMessage: 'Total Assets',
  },
  TWO_LETTER_COUNTRY_CODE: {
    id: 'TWO_LETTER_COUNTRY_CODE',
    defaultMessage: 'Two-letter Country Code',
  },
  TYPE: {
    id: 'TYPE',
    defaultMessage: 'Type',
  },
  UNABLE_CONNECT_LDAP: {
    id: 'UNABLE_CONNECT_LDAP',
    defaultMessage: 'Unable to connect to LDAP/AD server.',
  },
  UNABLE_CONNECT_SERVER: {
    id: 'UNABLE_CONNECT_SERVER',
    defaultMessage: 'Unable to connect to server.',
  },
  UNKNOWN_HOST_ERROR: {
    id: 'UNKNOWN_HOST_ERROR',
    defaultMessage:
      'Unable to connect to directory service due to an unknown host exception. Please check the hostname.',
  },
  UNKNOWN_LDAP_USER_ERROR: {
    id: 'UNKNOWN_LDAP_USER_ERROR',
    defaultMessage:
      "No user was found in the Identity Service with the account name '{accountName}'.",
  },
  useCustomPresets: {
    id: 'useCustomPresets',
    defaultMessage: 'Use Convert Presets',
  },
  USE_SSL: {
    id: 'USE_SSL',
    defaultMessage: 'Use SSL',
  },
  USER_ACCOUNT: {
    id: 'USER_ACCOUNT',
    defaultMessage: 'Account',
  },
  USER_CREATE: {
    id: 'USER_CREATE',
    defaultMessage: 'Add New User',
  },
  USER_DELETE: {
    id: 'USER_DELETE',
    defaultMessage: 'Delete Users',
  },
  USER_DELETE_CONFIRM: {
    id: 'USER_DELETE_CONFIRM',
    defaultMessage: 'Delete Selected Users?',
  },
  USER_DELETE__DELETE_PRIVATE: {
    id: 'USER_DELETE__DELETE_PRIVATE',
    defaultMessage: 'Permanently Deleted',
  },
  USER_DELETE__GALLERY_PROMPT: {
    id: 'USER_DELETE__GALLERY_PROMPT',
    defaultMessage:
      'Make Public makes all private and read-only galleries that belong to this user, public galleries. "Delete All Private Galleries" permanently removes private galleries, and makes read-only galleries public.',
  },
  USER_DELETE__GALLERY_PROMPT_1: {
    id: 'USER_DELETE__GALLERY_PROMPT_1',
    defaultMessage:
      "The users' Checked Out items will be reverted and made accessible.",
  },
  USER_DELETE__GALLERY_PROMPT_2: {
    id: 'USER_DELETE__GALLERY_PROMPT_2',
    defaultMessage: "The users' Read-Only Galleries will be made Public.",
  },
  USER_DELETE__GALLERY_PROMPT_3: {
    id: 'USER_DELETE__GALLERY_PROMPT_3',
    defaultMessage: "The users' Private Galleries should be:",
  },
  USER_DELETE__MAKE_PUBLIC: {
    id: 'USER_DELETE__MAKE_PUBLIC',
    defaultMessage: 'Made Public',
  },
  USER_DETAILS: {
    id: 'USER_DETAILS',
    defaultMessage: 'User Details',
  },
  USER_IMPORT: {
    id: 'USER_IMPORT',
    defaultMessage: 'Import Users',
  },
  USER_IMPORT_ACCOUNT: {
    id: 'USER_IMPORT_ACCOUNT',
    defaultMessage: 'Account Name',
  },
  USER_IMPORT_ACCOUNT_ATTR: {
    id: 'USER_IMPORT_ACCOUNT_ATTR',
    defaultMessage: 'Account Attribute',
  },
  USER_IMPORT_EMAIL_ATTR: {
    id: 'USER_IMPORT_EMAIL_ATTR',
    defaultMessage: 'Email Attribute',
  },
  USER_IMPORT_IMPORT: {
    id: 'USER_IMPORT_IMPORT',
    defaultMessage: 'Import',
  },
  USER_IMPORT_IMPORT_SELECTED_USERS: {
    id: 'USER_IMPORT_IMPORT_SELECTED_USERS',
    defaultMessage: 'Import Selected Users',
  },
  USER_IMPORT_MODIFY_SEARCH: {
    id: 'USER_IMPORT_MODIFY_SEARCH',
    defaultMessage: 'Modify Search',
  },
  USER_IMPORT_NAME_ATTR: {
    id: 'USER_IMPORT_NAME_ATTR',
    defaultMessage: 'Account Name Attribute',
  },
  USER_IMPORT_NOTES_ATTR: {
    id: 'USER_IMPORT_NOTES_ATTR',
    defaultMessage: 'Notes Attribute',
  },
  USER_IMPORT_PASSWORD: {
    id: 'USER_IMPORT_PASSWORD',
    defaultMessage: 'Account Password',
  },
  USER_IMPORT_PASSWORD_ATTR: {
    id: 'USER_IMPORT_PASSWORD_ATTR',
    defaultMessage: 'Password Attribute',
  },
  USER_IMPORT_SEARCH: {
    id: 'USER_IMPORT_SEARCH',
    defaultMessage: 'Search',
  },
  USER_IMPORT_SEARCH_BASE: {
    id: 'USER_IMPORT_SEARCH_BASE',
    defaultMessage: 'Search Base',
  },
  USER_IMPORT_SEARCH_FILTER: {
    id: 'USER_IMPORT_SEARCH_FILTER',
    defaultMessage: 'Search Filter',
  },
  USER_IMPORT_SERVER_ADDRESS: {
    id: 'USER_IMPORT_SERVER_ADDRESS',
    defaultMessage: 'Server Address',
  },
  USER_IMPORT_SPECIFY_LDAP_SERVER: {
    id: 'USER_IMPORT_SPECIFY_LDAP_SERVER',
    defaultMessage: 'Specify LDAP Server',
  },
  USER_LEVEL_ADMINISTRATOR: {
    id: 'USER_LEVEL_ADMINISTRATOR',
    defaultMessage: 'Catalog Administrator',
  },
  USER_LEVEL_EDITOR: {
    id: 'USER_LEVEL_EDITOR',
    defaultMessage: 'Editor',
  },
  USER_LEVEL_NON_MEMBER: {
    id: 'USER_LEVEL_NON_MEMBER',
    defaultMessage: '--',
  },
  USER_LEVEL_PUBLISHER: {
    id: 'USER_LEVEL_PUBLISHER',
    defaultMessage: 'Publisher',
  },
  USER_LEVEL_READER: {
    id: 'USER_LEVEL_READER',
    defaultMessage: 'Reader',
  },
  USER_MANAGE_CATALOGS: {
    id: 'USER_MANAGE_CATALOGS',
    defaultMessage: 'Manage Catalogs for Selected Users',
  },
  USER_MULT_USERS_SELECTED: {
    id: 'USER_MULT_USERS_SELECTED',
    defaultMessage: 'Multiple Users Selected',
  },
  USER_NAME: {
    id: 'USER_NAME',
    defaultMessage: 'User Name',
  },
  USER_NEW_USER_DETAILS: {
    id: 'USER_NEW_USER_DETAILS',
    defaultMessage: 'New User Details',
  },
  USER_NEW_USER_INFO_MSG: {
    id: 'USER_NEW_USER_INFO_MSG',
    defaultMessage: 'To add a user to specific catalogs, use Catalogs > Users.',
  },
  USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS: {
    id: 'USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS',
    defaultMessage: 'Add user to all catalogs as:',
  },
  USER_NO_USERS_SELECTED: {
    id: 'USER_NO_USERS_SELECTED',
    defaultMessage: 'No Users Selected',
  },
  USER_ONLINE: {
    id: 'USER_ONLINE',
    defaultMessage: 'Online',
  },
  USER_PASSWORD_TOO_SHORT: {
    id: 'USER_PASSWORD_TOO_SHORT',
    defaultMessage: 'Password must contain at least one character.',
  },
  USER_PASSWORDS_DO_NOT_MATCH: {
    id: 'USER_PASSWORDS_DO_NOT_MATCH',
    defaultMessage:
      'The password confirmation field needs to match the password field.',
  },
  USER_ROLE: {
    id: 'USER_ROLE',
    defaultMessage: 'Role',
  },
  USER_VIEW_DETAILS: {
    id: 'USER_VIEW_DETAILS',
    defaultMessage: 'View/Edit User Details',
  },
  USERS: {
    id: 'USERS',
    defaultMessage: 'Users',
  },
  VALIDATION_FIELD_LENGTH_EXCEEDED: {
    id: 'VALIDATION_FIELD_LENGTH_EXCEEDED',
    defaultMessage: 'This field cannot exceed 255 characters.',
  },
  VALIDATION_MUST_BE_NONEMPTY: {
    id: 'VALIDATION_MUST_BE_NONEMPTY',
    defaultMessage: 'This field is required.',
  },
  VIEW_EDIT_MAPPINGS: {
    id: 'VIEW_EDIT_MAPPINGS',
    defaultMessage: 'View / Edit Mappings',
  },
  couldNotConnect: {
    id: 'AUTH.couldNotConnect',
    defaultMessage:
      'Could not connect to the server. Please check the address.',
  },
  serverUnavailable: {
    id: 'ERROR.serverUnavailable',
    defaultMessage: 'The Portfolio server is not available.',
  },
  sessionExpired: {
    id: 'ERROR.sessionExpired',
    defaultMessage: 'Your session has expired.',
  },
  fileNotFound: {
    id: 'fileNotFound',
    defaultMessage: 'The file was not found on disk.',
  },
  invalidSearchFailed: {
    id: 'ERROR.invalidSearchFailed',
    defaultMessage:
      'The search failed because there was a problem with the query.',
  },
  loginFailed: {
    id: 'AUTH.loginFailed',
    defaultMessage: 'The username and password were incorrect.',
  },
  insufficientPrivileges: {
    id: 'FAULT_CODE.InsufficientPrivileges',
    defaultMessage:
      'You have insufficient privileges to perform this operation.',
  },
  unexpectedError: {
    id: 'unexpectedError',
    defaultMessage: 'An unexpected error occurred.',
  },
  refresh: {
    id: 'REFRESH',
    defaultMessage: 'Refresh',
  },

  // Reports

  ALL_CATALOGS: {
    id: 'ALL_CATALOGS',
    defaultMessage: 'All Catalogs',
  },
  ALL_SITES: {
    id: 'ALL_SITES',
    defaultMessage: 'All Sites',
  },
  ASSET_DOWNLOADS: {
    id: 'ASSET_DOWNLOADS',
    defaultMessage: 'Assets - Most Downloaded',
  },
  ASSET_PREVIEWS: {
    id: 'ASSET_PREVIEWS',
    defaultMessage: 'Assets - Most Previewed',
  },
  ASSET_UPLOADS: {
    id: 'ASSET_UPLOADS',
    defaultMessage: 'Assets - Uploads',
  },
  DOWNLOAD_REPORT: {
    id: 'DOWNLOAD_REPORT',
    defaultMessage: 'Download Report',
  },
  FILE_TYPES: {
    id: 'FILE_TYPES',
    defaultMessage: 'File Types',
  },
  FROM: {
    id: 'FROM',
    defaultMessage: 'From',
  },
  SITE: {
    id: 'SITE',
    defaultMessage: 'Site',
  },
  KEYWORD_STATISTICS: {
    id: 'KEYWORD_STATISTICS',
    defaultMessage: 'Keyword Statistics',
  },
  NETPUBLISH_MOST_DOWNLOADED: {
    id: 'NETPUBLISH_MOST_DOWNLOADED',
    defaultMessage: 'NetPublish - Most Downloaded',
  },
  NETPUBLISH_USAGE: {
    id: 'NETPUBLISH_USAGE',
    defaultMessage: 'NetPublish - Usage',
  },
  REPORT_NAME_DELETED_BY: {
    id: 'REPORT_NAME_DELETED_BY',
    defaultMessage: 'Assets - Deletions',
  },
  REPORT_NAME_DOWNLOADED_BY: {
    id: 'REPORT_NAME_DOWNLOADED_BY',
    defaultMessage: 'Assets - Downloads',
  },
  REPORT_DESCRIPTION_ASSET_PREVIEWS: {
    id: 'REPORT_DESCRIPTION_ASSET_PREVIEWS',
    defaultMessage:
      'This report identifies which assets were previewed and how many times each was previewed.',
  },
  REPORT_DESCRIPTION_ASSET_UPLOADS: {
    id: 'REPORT_DESCRIPTION_ASSET_UPLOADS',
    defaultMessage:
      'This report identifies uploaded assets, which users uploaded them, and when.',
  },
  REPORT_DESCRIPTION_DELETED_BY: {
    id: 'REPORT_DESCRIPTION_DELETED_BY',
    defaultMessage:
      'This report identifies deleted assets, which users deleted them, and when.',
  },
  REPORT_DESCRIPTION_DOWNLOADED_BY: {
    id: 'REPORT_DESCRIPTION_DOWNLOADED_BY',
    defaultMessage:
      'This report identifies downloaded assets, which users downloaded them, and when.',
  },
  REPORT_DESCRIPTION_DOWNLOADED: {
    id: 'REPORT_DESCRIPTION_DOWNLOADED',
    defaultMessage:
      'This report identifies which assets were downloaded and how many times each was downloaded.',
  },
  REPORT_DESCRIPTION_KEYWORD: {
    id: 'REPORT_DESCRIPTION_KEYWORD',
    defaultMessage:
      'This report identifies all the keywords in a catalog and how many assets they are applied to.',
  },
  REPORT_DESCRIPTION_USAGE: {
    id: 'REPORT_DESCRIPTION_USAGE',
    defaultMessage:
      'This report identifies which users downloaded which assets, and when.',
  },
  REPORT_DESCRIPTION_FILE_TYPES: {
    id: 'REPORT_DESCRIPTION_FILE_TYPES',
    defaultMessage:
      'This report identifies your most common file types and how much disk space they occupy.',
  },
  REPORT_DESCRIPTION_SEARCH_TERMS: {
    id: 'REPORT_DESCRIPTION_SEARCH_TERMS',
    defaultMessage:
      'This report identifies the most common words and phrases for which your users are searching in QuickFind.',
  },
  SEARCH_TERMS: {
    id: 'SEARCH_TERMS',
    defaultMessage: 'Search Terms',
  },
  TO: {
    id: 'TO',
    defaultMessage: 'To',
  },
  VIEW_REPORT: {
    id: 'VIEW_REPORT',
    defaultMessage: 'View Report',
  },
  REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE: {
    id: 'REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE',
    defaultMessage:
      'Remove { affectedUsersCount, plural, one {User} other {{affectedUsersCount} Users} } from Catalog',
  },
  REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG: {
    id: 'REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG',
    defaultMessage:
      "Are you sure you want to remove the { affectedUsersCount, plural, one {user} other {selected users} } from the catalog?\n\nThe { affectedUsersCount, plural, one {user's} other {selected users'} } Checked Out items in this catalog will be reverted and made accessible.",
  },
  CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG: {
    id: 'CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG',
    defaultMessage:
      "Are you sure you want to change the { affectedUsersCount, plural, one {user's role} other {selected users' roles} } in the catalog?\n\nThis action can be destructive to the { affectedUsersCount, plural, one {user's} other {selected users'} } data if the new role has reduced access or permissions.",
  },
  DUPLICATE_FIELD_NAME_ERROR: {
    id: 'DUPLICATE_FIELD_NAME_ERROR',
    defaultMessage: 'Duplicate Field Name',
  },
  EXTENSIS_CONTACT_US_URL: {
    id: 'EXTENSIS_CONTACT_US_URL',
    defaultMessage:
      'https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option',
  },
  EXTENSIS_SUPPORT_URL: {
    id: 'EXTENSIS_SUPPORT_URL',
    defaultMessage: 'https://help.portfoliodam.com/hc/en-us/requests/new',
  },
  LIC_CONTACT_CUSTOMER_SUCCESS_1: {
    id: 'LIC_CONTACT_CUSTOMER_SUCCESS_1',
    defaultMessage:
      'For assistance with renewing your account, please contact us at',
  },
  LIC_CONTACT_CUSTOMER_SUCCESS_2: {
    id: 'LIC_CONTACT_CUSTOMER_SUCCESS_2',
    defaultMessage:
      'and your Customer Success Manager will contact you within 1 business day.',
  },
  LIC_ERROR_GET_ACCOUNT: {
    id: 'LIC_ERROR_GET_ACCOUNT',
    defaultMessage: 'There was a problem getting your Extensis Account.',
  },
  LIC_ERROR_GET_LICENSES: {
    id: 'LIC_ERROR_GET_LICENSES',
    defaultMessage:
      'There was a problem retrieving your licenses from Extensis.',
  },
  LIC_SET_EXTENSIS_ACCOUNT: {
    id: 'LIC_SET_EXTENSIS_ACCOUNT',
    defaultMessage: 'Set Extensis Account',
  },
  LIC_SET_ACCOUNT: {
    id: 'LIC_SET_ACCOUNT',
    defaultMessage: 'Set Account',
  },
  LIC_REMOVE_ACCOUNT: {
    id: 'LIC_REMOVE_ACCOUNT',
    defaultMessage: 'Remove Account',
  },
  LIC_ACCOUNT: {
    id: 'LIC_ACCOUNT',
    defaultMessage: 'Email',
  },
  LIC_PASSWORD: {
    id: 'LIC_PASSWORD',
    defaultMessage: 'Password',
  },
  LIC_SYSTEM_ID: {
    id: 'LIC_SYSTEM_ID',
    defaultMessage: 'System ID',
  },
  LIC_SET_ACCOUNT_ERROR: {
    id: 'LIC_SET_ACCOUNT_ERROR',
    defaultMessage:
      'There was a problem setting your Extensis Account. Please check the credentials and try again.',
  },
  LIC_SET_SYSTEM_TITLE: {
    id: 'LIC_SET_SYSTEM_TITLE',
    defaultMessage: 'Select Your Extensis System',
  },
  PDL_noPredefinedValues: {
    id: 'PDL_noPredefinedValues',
    defaultMessage: 'No Predefined Values',
  },
  PDL_editPredefinedListPlaceholder: {
    id: 'PDL_editPredefinedListPlaceholder',
    defaultMessage: 'Edit Predefined List',
  },
  PDL_importPredefinedValues: {
    id: 'PDL_importPredefinedValues',
    defaultMessage: 'Import Predefined Values',
  },
  PDL_exportPredefinedValues: {
    id: 'PDL_exportPredefinedValues',
    defaultMessage: 'Export Predefined Values',
  },
  PDL_removeNestedValueConfirmation: {
    id: 'PDL_removeNestedValueConfirmation',
    defaultMessage:
      'Delete the selected values?\nThey contain nested values which will also be deleted.',
  },
  PDL_wrongPdlImportFormat: {
    id: 'PDL_wrongPdlImportFormat',
    defaultMessage:
      'The selected file did not contain text data. Please select a text file.',
  },
});

export default localizedStrings;



// WEBPACK FOOTER //
// ./src/util/localizedStrings.js